import React, { memo, useEffect, useState } from 'react';
import {
  Typography,
  Autocomplete,
  TextField,
  MenuItem,
  Checkbox,
  InputAdornment,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { Box } from '@mui/system';
import ClearIcon from '@mui/icons-material/Clear';
import Grid from '@mui/material/Grid';
import { API, graphqlOperation } from 'aws-amplify';
import VoucherComponent from './VoucherComponent';
import AddressDetails from './AddressDetails';
import { getAccountBalance, getPartyInvoices, listLineItems, listPartyMasterSearch } from '../../../graphql';
import LabelIcon from './LabelIcon';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import NewItemListModal from '../Modals/NewItemListModal';
import AddBox from '@mui/icons-material/AddBox';
import { grey } from '@mui/material/colors';
import AddNewPartyModal from '../Modals/AddNewPartyModal';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import PageResetModal from '../Modals/PageResetModal';
import { billingCurrencyOptions } from '../../../utils/Data/StaticData';

import { fetchPosList } from '../../../redux/reducers/posList';
import { useThemes } from '../../../components/Theme/theme';
import { fetchStateList } from '../../../redux/reducers/stateList';
import { fetchCountryList } from '../../../redux/reducers/countryList';
// import {
//   allTaxabilityOptios,
//   compositeSupplierTaxability,
//   compositeTaxability,
//   customertaxabilityOpions,
//   taxabilityOpions,
//   taxabilityOutSideIndia,
//   unrSupplierTaxability,
// } from "./InvoiceData";
import { getCodeTranslation, getPartyAddressEntity, getPartyMaster } from '../../../graphql';
import { useStateList } from './HandleInvoiceStateProvider';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { useAccountDetails } from './AccountDetailsProvider';
import { LedgerTransactionModalv2 } from '../../LedgerTransaction/TransactionsModal';
import useInfiniteScroll from './UseInfiniteScroll';
import { useTaxabilityOptions } from './UseTaxabilityOptions';
import { CheckBox, CheckBoxOutlineBlankOutlined, ElevatorSharp } from '@mui/icons-material';
import { UseShareModal } from './UseShareModal';
import { formatNumber } from '../../../utils/common';
import { useListGeneralSettingQuery } from '../../../redux/apis/newVoucherSettings.api';
function InvoiceBasicDetails({ todayDate, moment, partyTypeCD, params, invoiceLabels, Type }) {
  const { theme } = useThemes();
  const {
    setInitialState,
    data,
    setData,

    accNames,


    invoiceEntry,

    totNetAmt,

    companyState,
    setCompanyState,

    companyData,
    setCompanyData,
    partyDeliveryAddressEntity,
    setPartyDeliveryAddressEntity,
    partyBillAddressEntity,
    setPartyBillAddressEntity,

    partyNameOptions,
    setPartyNameOptions,
    partyAccountID,
    setPartyAccountID,

    voucherArr,
    setVoucherArr,

    setBackdropOpen,

    unitsObj,
    itemCodes,
    setItemCodes,
    itemNames,
    setItemNames,
    lastInvoiceDate,
    firstInvoiceDate,
    nextInvoiceDate,
    registrationType,
    setRegistrationType,

    partyType,
    setPartyType,

    items,
    setItems,
    nonItems,
    setNonItems,
    billingAddressDetails,
    setBillingAddressDetails,
    deliveryAddressDetails,
    setDeliveryAddressDetails,
    originalInvoiceNos,
    setOriginalInvoiceNos,
    partyRowFrom,
    setPartyRowFrom,
    activeVouchers,
    generalSettingsFlag,
    setGeneralSettingsFlag
  } = useStateList();
  const accountDetails = useAccountDetails();
  const { setIsLoading, ListboxProps, PaperComponent } = useInfiniteScroll(listPartyDetails, partyRowFrom, setPartyRowFrom);
  const [isSalesShow, handleCheckboxChange] = UseShareModal({
    attributeTypeCd: 'SalesPrint',
  });
  
  const userPreferenceAndFY = useSelector((state) => state.userPrefrenceandReducer);
  const { data: generalSettings } = useListGeneralSettingQuery(
      {
        entrytypecd: invoiceLabels.voucherType,
        financialyearid: userPreferenceAndFY?.financialYear?.financialyearid,
      },
      {
        refetchOnMountOrArgChange: true,
      }
    );
    const voucherFlag = generalSettings?.find((item) => item.expiredtimestamp === 0)?.nextinvoicenumber;

  const {
    allTaxabilityOptions,

    taxabilityOptions,
    compositeTaxability,
    taxabilityOutsideIndia,
    compositeTaxabilityForCustomer,

    unrSupplierTaxability,
    customerTaxabilityOptions,
  } = useTaxabilityOptions();
  const [listOfStates, setListOfStates] = useState([]);
  const [stateArr, setStateArr] = useState([]);
  const [countryArr, setCountryArr] = useState([]);
  const [districtArr, setDistrictArr] = useState([]);
  const [cityArr,setCityArr]=useState([]);
  const [stateName, setStateName] = useState('');
  const [districtName, setDistrictName] = useState('');
  const [countryName, setCountryName] = useState('');
  const [stateDelName, setStateDelName] = useState('');
  const [districtDelName, setDistrictDelName] = useState('');
  const [countryDelName, setCountryDelName] = useState('');
  const [accountBalance, setAccountBalance] = useState({ accBal: 0, balSign: 0 });
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [itemListModalOpen, setItemListModalOpen] = useState(false);
  const [openPartyModal, setOpenPartyModal] = useState(false);
  const [partyCategery, setPartyCategery] = useState(false);
  const [newPartyID, setNewPartyID] = useState('');
  const [partyParamsID, setPartyParamsID] = useState('');
  const [purchaseArr, setPurchaseArr] = useState([]);
  const [companyGstType, setCompanyGstType] = useState('');
  const [ledgerModal, setLedgerModal] = useState(false);
  const [companyPlaceofState, setCompanyPlaceOfState] = useState({
    label: '',
    value: '',
  });
  const [openResetModal, setOpenResetModal] = useState(false);
  const [showAllCurrencies, setShowAllCurrencies] = useState(false);
  const [newChangeValue, setNewChangeValue] = useState({
    label: '',
    value: '',
    type: '',
  });
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  let prev = useSelector((state) => state.eInvReducer);
  let companyType = getCompany?.relatedcompanydetailsnew?.[0].registrationtype;
  async function getCompanyDetails() {
    try {
      if (getCompany !== null) {
        setCompanyData(getCompany);
        setRegistrationType(getCompany?.relatedcompanydetailsnew?.[0].registrationtype);
        setCompanyGstType(getCompany?.relatedcompanydetailsnew?.[0].registrationtype);
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  }
  let stateValue = useSelector((state) => state);
  const init = async () => {
    try {
      if ((stateValue?.posListReducer?.posList?.listPlaceOfSupply?.length ?? 0) === 0) {
        let arry = await dispatch(fetchPosList());
      }
      if ((stateValue?.stateListReducer.stateList?.getCodeTranslation?.length ?? 0) === 0) {
        await dispatch(fetchStateList());
      }
      if ((stateValue.countryListReducer?.countryList?.getCodeTranslation?.length ?? 0) === 0) {
        await dispatch(fetchCountryList());
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('Error', error);
    } finally {
    }
  };
  useEffect(() => {
    init();
  }, []);
  useEffect(() => {
    if (accountDetails) {
      if (accountDetails?.PartyTypeCd && !newPartyID) {
        handlePartyCategoryChange(accountDetails?.value);
      } else {
        if (accountDetails?.type !== 'GOODS' && accountDetails?.type !== 'SERVICE') {
          const updatedNonItems = [...nonItems];
          updatedNonItems[0] = {
            ...updatedNonItems[0],
            ledgerAccount: {
              label: accountDetails?.label,
              value: accountDetails?.accountsid,
            },
          };
          setNonItems(updatedNonItems);
        }
      }
    }
  }, [accountDetails, partyNameOptions]);

  async function getStates() {
    try {
      let listing = stateValue?.posListReducer?.posList?.listPlaceOfSupply;
      let statesArray = listing?.map((element) => {
        return {
          label: `(${element?.statecode})   ${element?.statename}`,

          value: element?.statecode,
        };
      });
      setListOfStates(statesArray);
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }

  function getInitialStates() {
    let listing = stateValue?.posListReducer?.posList?.listPlaceOfSupply;
    let statesArray = listing?.map((element) => {
      return {
        label: `(${element?.statecode})   ${element?.statename}`,

        value: element?.statecode,
      };
    });
    let companyState = getCompany?.relatedaddressentity?.[0]?.statecode;

    let placeOfSupply = { label: '', value: '' };
    let companyStateCode = '';
    statesArray?.map((ele) => {
      if (ele.value == companyState) {
        companyStateCode = ele.value;
        placeOfSupply = { label: ele.label, value: ele.value };
      }
    });
    setCompanyPlaceOfState(placeOfSupply);
    setCompanyState(companyStateCode);
    if (data.partyName.value === '') {
      setData((prev) => ({
        ...prev,
        placeOfSupply: placeOfSupply,
      }));
      if (setInitialState) {
        setInitialState((prev) => ({
          ...prev,
          placeOfSupply: placeOfSupply,
        }));
      }
    }
  }
  async function listPartyDetails(word, rowfrom, limitno) {
    let partyGstCategory = '';
    let partyOBj = {};
    let creditLimit = 0;
    let optionArr = [];
    let type = Type === 'Sales' ? 'Customer' : Type === 'Purchase' ? 'Supplier' : '';

    try {
      const res = await API.graphql(
        graphqlOperation(listPartyMasterSearch, {
          word: word,
          type: type,
          rowfrom: rowfrom,
          limitno: limitno,
        })
      );
      if (res.data.listPartyMasterSearch.length !== 0) {
        let activePartyMasters = res.data.listPartyMasterSearch.filter((ele) => {
          if (ele.is_active === 1) {
            return ele;
          }
        });
        activePartyMasters.map((ele) => {
          if (Type === 'Sales' || Type === 'Purchase') {
            if (ele.partytypecd === partyTypeCD) {
              optionArr.push({
                label: ele?.partydisplayname,
                value: ele.partyid,
                legalName: ele?.partylegalname,
                email: ele?.email,
                consigneeGSTIN: ele.deliveryconsigneegstin,
                consigneeName: ele.deliveryconsigneename,
                accountsID: ele.accountsid,
                gstin: ele.relatedpartygstdetails?.[0]?.gstin,
                placeOfSupply: ele.placeofsupply,
                PartyTypeCd: ele.partytypecd,
                creditPeriod: ele.relatedpartycreditdetails?.[0].creditperiodduration,
                gstCategory: ele.gstcategory,
                billingCurrency: ele.relatedpartycreditdetails?.[0].billingcurrency,
                tdsSection: ele.tdssection,
                tdsPercentage: ele.tdspercentage,
                creditLimit:
                  Number(ele.relatedpartycreditdetails?.[0].creditlimitamount) > 0
                    ? ele.relatedpartycreditdetails?.[0].creditlimitamount
                    : 0,
              });
            }
            partyGstCategory = ele.gstcategory;
          } else {
            optionArr.push({
              label: ele?.partydisplayname,
              value: ele.partyid,
              legalName: ele?.partylegalname,
              email: ele?.email,
              consigneeGSTIN: ele.deliveryconsigneegstin,
              consigneeName: ele.deliveryconsigneename,
              accountsID: ele.accountsid,
              gstin: ele.relatedpartygstdetails?.[0]?.gstin,
              placeOfSupply: ele.placeofsupply,
              PartyTypeCd: ele.partytypecd,
              creditPeriod: ele.relatedpartycreditdetails?.[0].creditperiodduration,
              gstCategory: ele.gstcategory,
              billingCurrency: ele.relatedpartycreditdetails?.[0].billingcurrency,
              tdsSection: ele.tdssection,
              tdsPercentage: ele.tdspercentage,
              creditLimit:
                Number(ele.relatedpartycreditdetails?.[0].creditlimitamount) > 0 ? ele.relatedpartycreditdetails?.[0].creditlimitamount : 0,
            });
            partyGstCategory = ele.gstcategory;
          }
        });

        // setPartyNameOptions((prev) => {
        //   const newOptions = optionArr.filter(
        //     (newItem) =>
        //       !prev.some((existingItem) => existingItem.value == newItem.value)
        //   );
        //   return [...prev, ...newOptions];
        // });
        setPartyNameOptions((prev) => {
          const updatedMap = new Map(prev.map((item) => [item.value, item]));

          optionArr.forEach((item) => {
            updatedMap.set(item.value, item); // this overwrites if exists
          });

          return Array.from(updatedMap.values());
        });
      } else {
        setIsLoading(true);
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  async function getPartyBillAddressEntityDetails(objID, objType) {
    try {
      const resDetails = await API.graphql(
        graphqlOperation(getPartyAddressEntity, {
          objectid: objID,
          objecttype: objType,
        })
      );
      let Data = resDetails.data.getPartyAddressEntity?.[0];
      
      
      if (Data) {
        setPartyBillAddressEntity(Data);
        setData((prev) => ({
          ...prev,
          billingAddress: Data?.line1,
        }));

        let nameOfState = { label: '', value: '',code:'' };
       
        

        let nameOfDistrict = { label: '', value: '' };
        if(resDetails.data.getPartyAddressEntity?.[0].countrycode==="IndiaState"){
        districtArr.map((ele) => {
          if (ele?.value?.trim()?.toLowerCase()  === resDetails.data.getPartyAddressEntity?.[0].district?.trim()?.toLowerCase() ) nameOfDistrict = { label: ele.label, value: ele.value };
        });
         stateArr.map((ele) => {
          if (ele.code == resDetails.data.getPartyAddressEntity?.[0].statecode)
            nameOfState = {
              label: ele.label,
              value: ele.value,
              code: ele?.code,
            };
        });
        getDistrictsModal(
          // resDetails.data.getPartyAddressEntity?.[0].statecode,
          nameOfState.value,
          resDetails.data.getPartyAddressEntity?.[0].district,

          setBillingAddressDetails
        );
        getStatesModal(
          resDetails.data.getPartyAddressEntity?.[0].countrycode,
          resDetails.data.getPartyAddressEntity?.[0].statecode,
          setBillingAddressDetails
        );
      }else{
        nameOfDistrict={label:resDetails.data.getPartyAddressEntity?.[0].foreigndistrict,value:resDetails.data.getPartyAddressEntity?.[0].foreigndistrict};
        nameOfState = {
              label: resDetails.data.getPartyAddressEntity?.[0].foreignstate,
              value: 0,
              code: 0,
            };
            setBillingAddressDetails((prev)=>({
              ...prev,
              stateCD:nameOfState,
              districtCD:nameOfDistrict
            }));
      }
        setDistrictName(nameOfDistrict);
        setStateName(nameOfState);
        let nameOfCountry = { label: '', value: '' };
        countryArr.map((ele) => {
          if (ele.value == resDetails.data.getPartyAddressEntity?.[0].countrycode) nameOfCountry = { label: ele.label, value: ele.value };
        });
        const nameOfCity={label:resDetails.data.getPartyAddressEntity?.[0].city??'',value:resDetails.data.getPartyAddressEntity?.[0].city??''}
        setCountryName(nameOfCountry);

        
        setBillingAddressDetails((prev) => ({
          ...prev,
          // billingAddress: resDetails?.data.getPartyAddressEntity?.[0]?.line1?.replace(/\*/g, ' '),
           billingAddress: resDetails?.data.getPartyAddressEntity?.[0]?.line1,
          country: resDetails.data.getPartyAddressEntity?.[0].countrycode,
          district: resDetails.data.getPartyAddressEntity?.[0].district,
          // city: resDetails.data.getPartyAddressEntity?.[0].city,
          city:nameOfCity,
          states: resDetails.data.getPartyAddressEntity?.[0].statecode,
          pincode: resDetails.data.getPartyAddressEntity?.[0].pincode,
          countryCD: nameOfCountry,
          customerName:data?.partyName?.label,
          gstin:data?.gstin
        }));
      } else {
        const deliveryObj = {
        billingAddress: "",
        states: { label: "", value: "" },
        district: { label: "", value: "" },
        country: { label: "", value: "" },
        city: { label: "", value: "" },
        pincode: "",
        stateCD: "",
        countryCD: "",
        districtCD: "",
        gstin: "",
        customerName: "",

        errorStatus: {
          deliveryAddress: false,
          states: false,
          district: false,
          country: false,
          pincode: false,
          gstin: false,
          customerName: false,
        },
        errorFields: {
          deliveryAddress: "",
          states: "",
          district: "",
          country: "",
          pincode: "",
          gstin: "",
          customerName: "",
        },
      };
        setPartyDeliveryAddressEntity({});
        setData((prev) => ({
          ...prev,
          deliveryAddress: '',
          billingAddress: '',
        }));
      }
    } catch (e) {
      setBackdropOpen(false);
      console.log(e, 'error');
    }
  }


  
  async function getPartyDeliveryAddressDetails(objID, objType) {
    const resPartyAddressEntityDetails = await API.graphql(
      graphqlOperation(getPartyAddressEntity, {
        objectid: objID,
        objecttype: objType,
      })
    );

    let partyAddressEntityData = resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0];
    
    if (partyAddressEntityData) {
       setPartyDeliveryAddressEntity(partyAddressEntityData);
      setData((prev) => ({
        ...prev,
        deliveryAddress: partyAddressEntityData?.line1,
      }));

      let nameOfState = { label: '', value: '',code:''};
       let nameOfDistrict = { label: '', value: '' };
        if(resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].countrycode==="IndiaState"){
      stateArr.map((ele) => {
        if (ele.code == resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].statecode)
          nameOfState = { label: ele.label, value: ele.value, code: ele?.code };
      });
      
      districtArr.map((ele) => {
        if (ele?.value?.trim()?.toLowerCase()  === resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0]?.district?.trim()?.toLowerCase() )
          nameOfDistrict = { label: ele.label, value: ele.value };
      });
      getDistrictsModal(
        // resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].statecode,
        nameOfState.value,
        resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].district,
        setDeliveryAddressDetails
      );
      getStatesModal(
        resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].countrycode,
        resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].statecode,
        setDeliveryAddressDetails
      );
      }else{
         nameOfDistrict={label:resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].foreigndistrict,value:resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].foreigndistrict};
        nameOfState = {
              label: resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].foreignstate,
              value: 0,
              code: 0,
            };
            setDeliveryAddressDetails((prev)=>({
              ...prev,
              stateCD:nameOfState,
              districtCD:nameOfDistrict
            }));
      }

      const nameOfCity={label:resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].city??'',value:resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].city??''}
    
      setStateDelName(nameOfState);
  
      
      setDistrictDelName(nameOfDistrict);
      let nameOfCountry = { label: '', value: '' };
      countryArr.map((ele) => {
        if (ele.value == resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].countrycode)
          nameOfCountry = { label: ele.label, value: ele.value };
      });
      setCountryDelName(nameOfCountry);
      
      setDeliveryAddressDetails((prev) => ({
        ...prev,
        deliveryAddress: resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]?.line1,
        country: resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].countrycode,
        district: resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].district,
        city: nameOfCity,
        // resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].city,
        states: resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].statecode,
        pincode: resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].pincode,
        countryCD: nameOfCountry,
        customerName:resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].consigneename,
        gstin:resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].consigneegstin
      }));
      setData((prev)=>({
        ...prev,
        consigneeName:resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]?.consigneename??'',
        consigneeGST:resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]?.consigneegstin??''
      }));
      setInitialState((prev)=>({
        ...prev,
        consigneeName:resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]?.consigneename??'',
        consigneeGST:resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]?.consigneegstin??''
      }));
    } else {
      const deliveryObj={
    deliveryAddress: "",
    states: { label: "", value: "" },
    district: { label: "", value: "" },
    country: { label: "", value: "" },
    city: { label: "", value: "" },
    pincode: "",
    stateCD: "",
    countryCD: "",
    districtCD: "",
    gstin: "",
    customerName: "",

    errorStatus: {
      deliveryAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      gstin: false,
      customerName: false,
    },
    errorFields: {
      deliveryAddress: "",
      states: "",
      district: "",
      country: "",
      pincode: "",
      gstin: "",
      customerName: "",
    },
  };
      setData((prev) => ({
        ...prev,
        deliveryAddress: '',
        billingAddress: '',
        consigneeName: '',
        consigneeGST: '',
      }));
      setPartyDeliveryAddressEntity({});
      setDeliveryAddressDetails(deliveryObj);
    }
  }

  async function getStatesModal(code, state, setAddressDetails) {
    try {
      let nameOfstate = { label: '', value: '', code: '' };
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: code }));
      if (cities?.data?.getCodeTranslation != null) {
        let statesArray = (cities?.data?.getCodeTranslation).map((element) => {
          return {
            label: element.codetext,
            value: `${element.codetext}District`,
            code: element?.statecode,
          };
        });

        statesArray.map((ele) => {
          if (ele.code == state) {
            nameOfstate = {
              label: ele.label,
              value: ele.value,
              code: ele?.code,
            };
          }
        });

        setAddressDetails((prev) => ({
          ...prev,
          stateCD: nameOfstate,
        }));
      }
    } catch (error) {
      setBackdropOpen(false);
    }
  }
  async function getDistrictsModal(state, district, setAddressDetails) {
    try {
      let nameOfDistrict = { label: '', value: '' };
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: state }));
      if (cities?.data?.getCodeTranslation != null) {
        let disArray = (cities?.data?.getCodeTranslation).map((element) => {
          return {
            label: element.codetext,
            value: `${element.codetext}District`,
          };
        });

        disArray.map((ele) => {
          if (ele.value?.trim()?.toLowerCase()   === district?.trim()?.toLowerCase()) {
            nameOfDistrict = { label: ele.label, value: ele.value };
          }
        });

        setAddressDetails((prev) => ({
          ...prev,
          districtCD: nameOfDistrict,
        }));
      }
    } catch (error) {
      setBackdropOpen(false);
    }
  }

  async function getInvoiceBasicDetails(invoiceEntry) {
    // setBackdropOpen(true);
    let invID = '';
    let partyID = '';
    let voucherNumber = '';
    let seriesVouchers={label:"",value:"",serialflag:0};
    let partyInvNo=""
    let invDate = '';
    let partyOrderDate = '';
    let partyOrderNumber = '';
    let taxType = { label: '', value: '' };
    let taxabilityType=0;
    let ITCFlag=0;
    let listing = stateValue?.posListReducer?.posList?.listPlaceOfSupply;
    let statesArray = listing?.map((element) => {
      return {
        label: `(${element?.statecode})   ${element?.statename}`,

        value: element?.statecode,
      };
    });
     if(invoiceEntry?.serialnumber===""){
        setGeneralSettingsFlag(-1);
     }else{
      setGeneralSettingsFlag("");
     }
    if (Type === 'Sales') {
      invID = invoiceEntry?.invoiceid;
      partyID = invoiceEntry?.partyid;
      taxabilityType=invoiceEntry?.taxability;
      ITCFlag=0;
        //  voucherNumber = invoiceEntry?.invoicenumber;
      if(invoiceEntry?.serialnumber===""){
      voucherNumber = invoiceEntry?.invoicenumber;
      }else{
        seriesVouchers={label:invoiceEntry?.invoicenumber,value:invoiceEntry?.serialnumber,serialflag:invoiceEntry?.serialflag};
      }
      
      invDate = invoiceEntry?.invoicedate;
      partyOrderDate = invoiceEntry?.customerorderdate;
      partyOrderNumber = invoiceEntry?.customerordernumber;
      allTaxabilityOptions.map((ele) => {
        if (ele.value == invoiceEntry?.invoicetaxabletypecd) taxType = { label: ele?.label, value: ele?.value };
      });
    }
    if (Type === 'Purchase') {
      invID = invoiceEntry?.purchaseid;
      partyID = invoiceEntry?.supplierid;
      ITCFlag=invoiceEntry?.itcflag;
      //  voucherNumber = invoiceEntry?.vouchernumber;
      if(invoiceEntry?.serialnumber===""){
      voucherNumber = invoiceEntry?.vouchernumber;
      }else{
        seriesVouchers={label:invoiceEntry?.vouchernumber,value:invoiceEntry?.serialnumber,serialflag:0};
      }
      invDate = invoiceEntry?.entrydate;
      partyOrderDate = invoiceEntry?.supplierinvoicedate === 0 ? '' : invoiceEntry?.supplierinvoicedate;
      partyOrderNumber = invoiceEntry?.supplierinvoicenumber;
      allTaxabilityOptions?.map((ele) => {
        if (ele.value == invoiceEntry?.purchasegsttypecd) taxType = { label: ele?.label, value: ele?.value };
      });
    }
    if (Type === 'DebitNote' || Type === 'CreditNote') {
      invID = invoiceEntry?.crdrnoteid;
      partyID = invoiceEntry?.partyid;
      partyInvNo=invoiceEntry?.partyinvoicenumber;
      ITCFlag=invoiceEntry?.itcflag;
      // voucherNumber = invoiceEntry?.crdrnotenumber;
      if(invoiceEntry?.serialnumber===""){
      voucherNumber = invoiceEntry?.crdrnotenumber;
      }else{
        seriesVouchers={label:invoiceEntry?.crdrnotenumber,value:invoiceEntry?.serialnumber,serialflag:0};
      }
      invDate = invoiceEntry?.crdrnotedate;
      allTaxabilityOptions?.map((ele) => {
        if (ele.value == invoiceEntry?.gsttypecd) taxType = { label: ele?.label, value: ele?.value };
      });
    }
    const formatDate = (dateString) => {
      const date = new Date(Number(dateString) * 1000);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };
    if (invoiceEntry?.length !== 0) {
      let accID = '';
      let accName = '';
      let partyType = '';
      let partyCategery = '';
      let billingCurrency = { label: '', value: '', sign: '', code: '' };
      billingCurrencyOptions?.map((ele) => {
        if (ele.value === invoiceEntry?.currencycode) {
          billingCurrency = {
            label: ele.label,
            value: ele.value,
            sign: ele.sign,
            code: ele.code,
          };
        }
      });
      let placeOfSupply = { label: '', value: '' };
      statesArray?.map((ele) => {
        if (ele.value == invoiceEntry?.placeofsupply) {
          placeOfSupply = { label: ele.label, value: ele.value };
        }
      });
      let partyNameObj = { label: '', value: '', gstCategorey: '' };
      const invoiceDate = formatDate(invDate);
      const resCustomerOrderDate = partyOrderDate ? formatDate(partyOrderDate) : '';
      if (Type === 'Sales') {
        getPartyDeliveryAddressDetails(invID, 'SalesDelivery');
        getPartyBillAddressEntityDetails(invID, 'SalesBilling');
      }
      if (Type === 'DebitNote') {
        getPartyDeliveryAddressDetails(invID, 'DebitDelivery');
        getPartyBillAddressEntityDetails(invID, 'DebitBilling');
      }
      if (Type === 'CreditNote') {
        getPartyDeliveryAddressDetails(invID, 'CreditDelivery');
        getPartyBillAddressEntityDetails(invID, 'CreditBilling');
      }

      if (Type === 'Purchase') {
        getPartyBillAddressEntityDetails(invID, 'PurchaseBilling');
        getPartyDeliveryAddressDetails(invID, 'PurchaseDelivery');
      }
      // getPartyDetails(partyID);
      // partyNameOptions.map((ele) => {
      //   if (ele.value === partyID) {
      //     accID = ele.accountsID;
      //     accName = ele.label;
      //     partyNameObj = {
      //       label: ele.label,
      //       value: ele.value,
      //       legalName: ele.legalName,
      //       gstCategorey: ele.gstCategory,
      //     };
      //     partyType = ele.PartyTypeCd;
      //     partyCategery = ele.gstCategory;
      //   }
      // });

      accID = invoiceEntry?.partyaccountid;
      accName = invoiceEntry?.partydisplayname;
      partyNameObj = {
        label: invoiceEntry?.partydisplayname,
        legalName: invoiceEntry?.partylegalname,
        accountsID: invoiceEntry.partyaccountid,
        value: partyID,
        ledgerName: invoiceEntry?.accountname,
        gstCategorey: invoiceEntry?.partygstcategory,
      };
      partyType = invoiceEntry?.partytypecd;
      partyCategery = invoiceEntry?.partygstcategory;

      // if (Type === "DebitNote" || Type === "CreditNote") {
      setPartyType(partyType);
      if (partyType === 'SUPPLIER') {
        let prevItemCodes = itemCodes.filter((item) => item.purchase === 1);
        let prevItemNames = itemNames.filter((item) => item.purchase === 1);

        setItemNames(prevItemNames);
        setItemCodes(prevItemCodes);
      }
      if (partyType === 'CUSTOMER') {
        let prevItemCodes = itemCodes.filter((item) => item.sales === 1);
        let prevItemNames = itemNames.filter((item) => item.sales === 1);

        setItemNames(prevItemNames);
        setItemCodes(prevItemCodes);
      }
      // }
      if (Type === 'DebitNote' || Type === 'CreditNote') {
        await getInvoiceVouchers(partyNameObj.value, partyType, invoiceDate, invoiceEntry);
      }
      if (
        // invoiceEntry?.partyregistrationtype === "UB" ||
        invoiceEntry?.partytypecd === 'SUPPLIER' &&
        invoiceEntry?.partyregistrationtype === 'RBCS'
      ) {
        setRegistrationType(1);
      } else {
        setRegistrationType(companyGstType);
      }

      displayAccountBalance(accID);
      setPartyAccountID(accID);
      // getModalData(accID);
      let dueDate = '';
      let datt = moment(
        new Date(
          (partyOrderDate === ''
            ? invDate
            : Type === 'Sales' || Type === 'DebitNote' || Type === 'CreditNote' || Type === 'Pos'
            ? invDate
            : partyOrderDate) * 1000
        )
      ).format('DD MMM YYYY');
      dueDate = moment(moment(datt)?.add(invoiceEntry?.creditduration, 'days')._d).format('DD MMM YYYY');
      setData((prev) => ({
        ...prev,
        partyName: {
          label: invoiceEntry?.partydisplayname,
          legalName: invoiceEntry?.partylegalname,
          value: partyID,
          accountsID: invoiceEntry.partyaccountid,
          ledgerName: invoiceEntry?.accountname,
          gstCategorey: invoiceEntry?.partygstcategory,
        },
        // partyNameObj,
        // partyCategory: partyCategery,
        placeOfSupply: placeOfSupply,
        voucherNumber: voucherNumber,
        seriesVouchers:seriesVouchers,
        invoiceDate: invoiceDate,
        customerOrderDate: resCustomerOrderDate,
        orderNumber: partyOrderNumber,
        consigneeName: invoiceEntry?.consigneename,
        gstin:  invoiceEntry?.partygstin || '',
        consigneeGST: invoiceEntry?.consigneegstin || '',
        currency: billingCurrency,
        currencyRate: invoiceEntry?.currencyrate,
        reverseChargeFlag: invoiceEntry?.reversechargeflag,
        partyCategory: invoiceEntry?.partytypecd === 'SUPPLIER' ? invoiceEntry?.partyregistrationtype : invoiceEntry?.partygstcategory,
        taxability: taxType,
        creditPeriod: invoiceEntry.creditduration,
        dueDate: dueDate,
        partyInvNo:partyInvNo,
        ITCFlag:ITCFlag,
        taxType:taxabilityType
      }));
      if (setInitialState) {
        setInitialState((prev) => ({
          ...prev,
          // partyName: partyNameObj,
          partyName: {
            label: invoiceEntry?.partydisplayname,
            legalName: invoiceEntry?.partylegalname,
            value: partyID,
            accountsID: invoiceEntry.partyaccountid,
            ledgerName: invoiceEntry?.accountname,
            gstCategorey: invoiceEntry?.partygstcategory,
          },
          partyCategory: invoiceEntry?.partytypecd === 'SUPPLIER' ? invoiceEntry?.partyregistrationtype : invoiceEntry?.partygstcategory,
          placeOfSupply: placeOfSupply,
          voucherNumber: voucherNumber,
          seriesVouchers:seriesVouchers,
          invoiceDate: invoiceDate,
          customerOrderDate: resCustomerOrderDate,
          orderNumber: partyOrderNumber,
          consigneeName: invoiceEntry?.consigneename,
          gstin: invoiceEntry?.consigneegstin || invoiceEntry?.partygstin || '',
          consigneeGST: invoiceEntry?.consigneegstin || '',
          currency: billingCurrency,
          currencyRate: invoiceEntry?.currencyrate,
          reverseChargeFlag: invoiceEntry?.reversechargeflag,
          taxability: taxType,
          creditPeriod: invoiceEntry.creditduration,
          dueDate: dueDate,
          ITCFlag:ITCFlag,
          taxType:taxabilityType,
        partyInvNo:partyInvNo
        }));
      }
    }
  }

  async function displayAccountBalance(id) {
    try {
      const res = await API.graphql(graphqlOperation(getAccountBalance, { accountid: id }));
      if (res.data.getAccountBalance.length > 0) {
        setAccountBalance({
          accBal: res.data.getAccountBalance?.[0]?.accountbalance,
          balSign: res.data.getAccountBalance?.[0]?.balancesign,
        });
      } else {
        setAccountBalance({ accBal: 0, balSign: 0 });
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  }

  async function listUserPreferenceData() {
    try {
      // const res = await API.graphql(graphqlOperation(listUserPreference));
      let attributeValue = '';
      let bankAttributeValue = '';
      // res?.data?.listUserPreference?.map((ele) => {
      userPreferenceAndFY.userPreference?.map((ele) => {
        if (ele.attributetypecd === 'SelectedFinYear') {
          attributeValue = ele.attributevalue;
        }
        if (ele.AttributeTypeCD === 'SelectedBankDetails') {
          bankAttributeValue = ele.attributevalue;
        }
      });
      getFY(userPreferenceAndFY?.financialYear?.financialyearid);
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  async function getFY(data) {
    try {
      setStartDate(userPreferenceAndFY.financialYear.startdate);
      setEndDate(userPreferenceAndFY.financialYear.enddate);
    } catch (error) {
      setBackdropOpen(false);
      console.log('Error', error);
    }
  }
  async function getInvoiceVouchers(Id, partyType, invDate, invoiceEntry) {    
    try {
      let invNo = [];
      let voucherNos = [];
      let invoiceDate = moment(new Date(invDate));
      const res = await API.graphql(
        graphqlOperation(getPartyInvoices, {
          partyid: Id,
          partytypecd: partyType,
        })
      );
      if (res?.data?.getPartyInvoices?.length > 0) {
        if (partyType === 'CUSTOMER') {
          res?.data?.getPartyInvoices?.map((ele) => {
            let voucherDate = moment(new Date(ele?.invoicedate) * 1000).startOf('day'); // Ensure no time is considered
            if (invoiceDate.isSameOrAfter(voucherDate)) {
              invNo.push({
                label: ele.invoicenumber,
                value: ele.invoiceid,
                regType: '',
                taxability: ele?.invoicetaxabletypecd,
                invDate: ele.invoicedate,
                currencycode:ele?.currencycode,
                partyInvNo:ele?.customerordernumber
              });
            }
          });
          // const filteredSelected = data?.originalInvoiceNumber.filter((ele) => invNo.some((subele) => ele.value === subele.value));

          // setData((prev) => ({
          //   ...prev,
          //   originalInvoiceNumber: filteredSelected,
          // }));
          // setInitialState((prev) => ({
          //   ...prev,
          //   originalInvoiceNumber: filteredSelected,
          // }));

          if (invoiceEntry) {
            let selected = { label: '', value: '', regType: '', taxability: '', invDate: '',currencycode:'' };
            // let array = invoiceEntry?.originalinvoicenumber?.split(',');

            // array.map((ele) => {
            invNo.map((subele) => {
              if (invoiceEntry?.originalinvoicenumber == subele.value) {
                // selected.push({
                //   label: subele.label,
                //   value: subele.value,
                //   regType: subele.regType,
                //   taxability: subele?.taxability,
                //   invDate: invoiceEntry.invDate,
                // });
                selected = {
                  label: subele.label,
                  value: subele.value,
                  regType: subele.regType,
                  taxability: subele?.taxability,
                  invDate: subele.invDate,
                  currencycode:subele?.currencycode,
                  partyInvNo:subele?.customerordernumber
                };
              }
            });
            // });
            // const arr = selected.map((ele) => ({
            //   type: 'Sales',
            //   id: ele.value,
            // }));
            const arr = [
              {
                type: 'Sales',
                id: selected.value,
              },
            ];
            if (arr.length > 0) {
              getLineItemDetails(arr);
            }
            setData((prev) => ({
              ...prev,
              originalInvoiceNumber: selected,
            }));
            setInitialState((prev) => ({
              ...prev,
              originalInvoiceNumber: selected,
            }));
          }
          // if (invNo.length === 0) {
          //   setData((prev) => ({
          //     ...prev,
          //     originalInvoiceNumber:sele,
          //   }));
          // }
          setOriginalInvoiceNos(invNo);
        }
        if (partyType === 'SUPPLIER') {
          res?.data?.getPartyInvoices?.map((ele) => {
            let voucherDate = moment(new Date(ele?.entrydate) * 1000).startOf('day'); // Ensure no time is considered
            if (invoiceDate.isSameOrAfter(voucherDate)) {
              voucherNos.push({
                label: ele.vouchernumber,
                value: ele.purchaseid,
                regType: ele.partyregistrationtype,
                taxability: ele?.purchasegsttypecd,
                invDate: ele?.entrydate,
                currencycode:ele?.currencycode,
                  partyInvNo:ele?.supplierinvoicenumber
                
              });
            }
          });
          // const filteredSelected = data?.originalInvoiceNumber.filter((ele) => voucherNos.some((subele) => ele.value === subele.value));

          // setData((prev) => ({
          //   ...prev,
          //   originalInvoiceNumber: filteredSelected,
          // }));

          // setInitialState((prev) => ({
          //   ...prev,
          //   originalInvoiceNumber: filteredSelected,
          // }));

          if (invoiceEntry) {
            invoiceDate = moment(new Date(invoiceEntry.crdrnotedate));
             let selected = { label: '', value: '', regType: '', taxability: '', invDate: '',currencycode:'' }
            // let array = invoiceEntry?.originalinvoicenumber.split(',');
            // array.map((ele) => {
            voucherNos.map((subele) => {
              if (invoiceEntry?.originalinvoicenumber == subele.value) {
                // selected.push({
                //   label: subele.label,
                //   value: subele.value,
                //   regType: subele.regType,
                //   taxability: subele?.taxability,
                //   invDate: invoiceEntry?.invDate,
                // });
                selected = {
                  label: subele.label,
                  value: subele.value,
                  regType: subele.regType,
                  taxability: subele?.taxability,
                  invDate: subele?.invDate,
                  currencycode:subele?.currencycode,
                  partyInvNo:subele?.supplierinvoicenumber
                };
              }
            });
            // });

            // const arr = selected.map((ele) => ({
            //   type: 'Purchase',
            //   id: ele.value,
            // }));
            const arr = [
              {
                type: 'Purchase',
                id: selected.value,
              },
            ];
            if (arr.length > 0) {
              getLineItemDetails(arr);
            }

            setData((prev) => ({
              ...prev,
              originalInvoiceNumber: selected,
              // partyInvNo:selected?.partyInvNo
            }));
            setInitialState((prev) => ({
              ...prev,
              originalInvoiceNumber: selected,
              // partyInvNo:selected?.partyInvNo
            }));
          }
          // if (voucherNos.length === 0) {
          //   setData((prev) => ({
          //     ...prev,
          //     originalInvoiceNumber: [],
          //   }));
          //   setInitialState((prev) => ({
          //     ...prev,
          //     originalInvoiceNumber: [],
          //   }));
          // }

          setOriginalInvoiceNos(voucherNos);
        }
      } else {
        setOriginalInvoiceNos([]);
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  // async function getCurrentCurrencyRate(code) {
  //   try {
  //     const response = await axios.get(`https://api.exchangerate-api.com/v4/latest/${code}`);
  //     if (response.data.rates.INR !== null) {
  //       setData((prev) => ({
  //         ...prev,
  //         currencyRate: Number(response.data.rates.INR).toFixed(2),
  //       }));
  //       if (setInitialState) {
  //         setInitialState((prev) => ({
  //           ...prev,
  //           currencyRate: Number(response.data.rates.INR).toFixed(2),
  //         }));
  //       }
  //     }
  //   } catch (error) {
  //     setBackdropOpen(false);
  //     console.log('error', error);
  //   }
  // }
  async function getCurrentCurrencyRate(baseCode, dateString) {
  try {

    const url = dateString
      ? `https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@${dateString}/v1/currencies/${baseCode.toLowerCase()}.json`
      : `https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/${baseCode.toLowerCase()}.json`;

    const response = await axios.get(url);
    const rate = response.data[baseCode.toLowerCase()].inr;

    const formatted = Number(rate).toFixed(2);

    setData(prev => ({ ...prev, currencyRate: formatted }));
    if (setInitialState) {
      setInitialState(prev => ({ ...prev, currencyRate: formatted }));
    }
  } catch (error) {
    setBackdropOpen(false);
    console.error('error', error);
  }
}

  const handlePartyChange = function (event, newValue) {
    handlePartyCategoryChange(newValue?.value);
  };
  const handleGSTINChange = function (event) {
    setData((prev) => ({
      ...prev,
      gstin: event.target.value,
    }));
  };
  const handlePlaceOfSupplyChange = function (event, newValue) {
    let prevPlaceOfSupply = data?.placeOfSupply?.value;

    if (data?.taxability?.value !== '' && newValue?.value === 96) {
      setOpenResetModal(true);
      setNewChangeValue({
        label: newValue?.label,
        value: newValue?.value,
        type: 'placeOfSupply',
      });
    } else if (data?.taxability?.value !== '' && prevPlaceOfSupply === 96 && newValue.value !== 96) {
      setOpenResetModal(true);
      setNewChangeValue({
        label: newValue?.label,
        value: newValue?.value,
        type: 'placeOfSupply',
      });
    } else {
      changeInPlaceOfSupply(newValue);
    }
  };
  const handlePlaceOfSupplyKeyDown = function (event) {
    const warMsg = '';
    const name = 'placeOfSupply';
    const currentId = 'placeOfSupply';
    const nextId = params?.id ? 'invoiceDate' : 'voucher';
    const prevID = 'partyName';
    const required = true;

    handleAutoCompleteKeyDown(event, setData, name, currentId, nextId, required, warMsg, prevID);
  };
  const handleCurrencyChange = function (event, newValue) {
    if (newValue?.value !== '' && newValue !== 'Show All Currencies') {
      getCurrentCurrencyRate(newValue.code,data?.invoiceDate);
      setData((prev) => ({
        ...prev,
        currency: newValue,
      }));
    }
  };

  const handleCurrencyKeyDown = function (event) {
    const name = 'currency';
    const currentId = 'currency';
    const nextId = data.currency.code !== 'INR' ? 'currencyRate' : 'invoiceDate';
    const prevID = 'voucher';
    const required = true;
    const warMsg = '';

    handleAutoCompleteKeyDown(event, setData, name, currentId, nextId, required, warMsg, prevID);
  };
  const toggleShowAllCurrencies = function (event) {
    event.stopPropagation();
    setShowAllCurrencies((prev) => !prev);
  };
  const handleCurrencyRateChange = function (e) {
    let value = e.target.value.replace(/,/g, ''); // Remove commas

    // Handling edge cases
    if (value === '0-') value = '-0';
    if (value === '-') value = '0';

    // Allow only valid numeric input
    if (!/^(-?\d*(?:\.\d*)?)$/.test(value)) return;

    setData((prev) => ({
      ...prev,
      currencyRate: value,
      errorStatus: {
        ...prev.errorStatus,
        currencyRate: value === '' ? true : false, // Set error if empty
      },
    }));
  };
  const handleInvoiceDateChange = (e) => {
    const value = e.target.value;
    // if (Type === 'CreditNote' || Type === 'DebitNote') {
    //   const momentInvoiceDate = moment(value, 'YYYY-MM-DD').startOf('day');
    //   const crDrDate = moment(new Date(data?.originalInvoiceNumber?.invDate) * 1000).startOf('day');

    //   if (crDrDate && momentInvoiceDate?.isBefore(crDrDate)) {
    // const message =
    //   Type === 'CreditNote'
    //     ? 'The Credit Note date cannot be earlier than the date of its related invoice. Please choose a date on or after the invoice date.'
    //     : 'The Debit Note date cannot be earlier than the date of its related invoice. Please choose a date on or after the invoice date.';
    //     showWarningSnackbar(message
    //     );
    //     return;
    //   }
    // }
    handleInvoiceDateChanges(value);
  };
    const handleInvoiceDateChangeBlur = (e) => {
    const value = e.target.value;
    if (Type === 'CreditNote' || Type === 'DebitNote') {
      const momentInvoiceDate = moment(value, 'YYYY-MM-DD').startOf('day');
      const crDrDate = moment(new Date(data?.originalInvoiceNumber?.invDate) * 1000).startOf('day');

      if (crDrDate && momentInvoiceDate?.isBefore(crDrDate)) {
    const message =
      Type === 'CreditNote'
        ? 'The Credit Note date cannot be earlier than the date of its related invoice. Please choose a date on or after the invoice date.'
        : 'The Debit Note date cannot be earlier than the date of its related invoice. Please choose a date on or after the invoice date.';
        showWarningSnackbar(message
        );
        return;
      }
    }
    handleInvoiceDateChanges(value);
  };
  const handleInvoiceDateKeyDown = (e) => {
    const element = Type === 'Sales' || Type === 'Purchase' ? 'orderNumber' : 'invVoucher';
    const warMsg = `${invoiceLabels.dateName} is required`;
    const name = 'invoiceDate';
    const currentId = 'invoiceDate';
    const nextId = element;
    const prevID = params?.id ? 'placeOfSupply' : data.currency.code !== 'INR' ? 'currencyRate' : 'currency';
    const required = true;

    handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
  };
 const handleOrderNumberChange = (e) => {
  const orderNumberRegex = /^[A-Za-z0-9/\- ]*$/; // just check allowed characters
  const inputValue = e.target.value;

  if (/\s{2,}/.test(inputValue)) {
    return; 
  }

  if (!orderNumberRegex.test(inputValue)) {
    showWarningSnackbar(
      `${invoiceLabels.orderNumberName} can only contain letters, numbers, hyphens (-), and slashes (/).`
    );
    return;
  }
  if (inputValue.length > 20) {
    showWarningSnackbar(
      `${invoiceLabels.orderNumberName} must be less than or equal to 20 characters`
    );
    return;
  }

  setData((prev) => ({
    ...prev,
    orderNumber: inputValue,
    
  }));
    setInitialState((prev) => ({
    ...prev,
    orderNumber: inputValue,
    
  }));
};

 const handlePartyNumberChange = (e) => {
  const orderNumberRegex = /^[A-Za-z0-9/\- ]*$/; // just check allowed characters
  const inputValue = e.target.value;

  if (/\s{2,}/.test(inputValue)) {
    return; 
  }

  if (!orderNumberRegex.test(inputValue)) {
    showWarningSnackbar(
      `${partyType==="CUSTOMER"?"Customer Order Number":"Supplier Invoice Number"} can only contain letters, numbers, hyphens (-), and slashes (/).`
    );
    return;
  }
  if (inputValue.length > 20) {
    showWarningSnackbar(
      `${partyType==="CUSTOMER"?"Customer Order Number":"Supplier Invoice Number"} must be less than or equal to 20 characters`
    );
    return;
  }

  setData((prev) => ({
    ...prev,
    partyInvNo: inputValue,
  }));
};


  const handleCustomerOrderDateChange = (e) => {
    const value = e.target.value;
    const orderDate = moment(value, 'YYYY-MM-DD', true); // Parse input date
    const invoiceDate = moment(data.invoiceDate, 'YYYY-MM-DD', true); // Parse invoice date
    const validCreditDate = Type === 'Sales' || Type === 'DebitNote' || Type === 'CreditNote' || Type === 'Pos' ? data?.invoiceDate : value;

    if (!value && value !== '') {
      setData((prev) => ({
        ...prev,
        customerOrderDate: '',
        errorStatus: { ...prev.errorStatus, customerOrderDate: true },
        errorFields: {
          ...prev.errorFields,
          customerOrderDate: 'Invalid date format.',
        },
      }));
    } 
    // else if (orderDate.isAfter(invoiceDate)) {
    //   setData((prev) => ({
    //     ...prev,
    //     customerOrderDate: value,
    //     errorStatus: { ...prev.errorStatus, customerOrderDate: true },
    //     errorFields: {
    //       ...prev.errorFields,
    //       customerOrderDate: `${invoiceLabels.orderDateName} cannot be later than ${invoiceLabels.dateName}.`,
    //     },
    //   }));
    // } 
    else {
      setData((prev) => ({
        ...prev,
        customerOrderDate: value,
        dueDate: moment(validCreditDate)?.add(data?.creditPeriod, 'days').format('DD MMM YYYY'),
        errorStatus: { ...prev.errorStatus, customerOrderDate: false },
        errorFields: { ...prev.errorFields, customerOrderDate: '' },
      }));
    }
  };

  const handleCustomerOrderDateKeyDown = (e) => {
    let updatedTableArr = [...items];
    const zeroSalesIndex =
      updatedTableArr.findIndex((row) => row.itemCode.value === '') !== -1
        ? updatedTableArr.findIndex((row) => row.itemCode.value === '')
        : updatedTableArr.findIndex((row) => row.itemCode.value !== '');

    // const element = "itemCode" + zeroSalesIndex;
    const element = 'creditPeriod';
    const warMsg = `${invoiceLabels.orderDateName} is required`;
    const name = 'customerOrderDate';
    const currentId = 'customerOrderDate';
    const nextId = companyType == 1 ? element : 'taxability';
    const prevID = 'orderNumber';
    const required = true;

    handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
  };
  const handleInvoiceChange = (e, newValue) => {
    
    
    const { taxability } = newValue;

    let taxType = { label: '', value: '' };
    allTaxabilityOptions.forEach((ele) => {
      if (ele?.value == taxability) {
        taxType = { label: ele?.label, value: ele?.value };
      }
    });
    let billingCurrency = { label: '', value: '', sign: '', code: '' };
      billingCurrencyOptions.map((ele) => {
        if (ele.value === newValue?.currencycode) {
          billingCurrency = {
            label: ele.label,
            value: ele.value,
            sign: ele.sign,
            code: ele.code,
          };
        }
      });
    getCurrentCurrencyRate(billingCurrency?.code,data?.invoiceDate);
    handleTaxabilityChange(taxType, items, nonItems);
    const arr = [
      {
        type: partyType === 'CUSTOMER' ? 'Sales' : 'Purchase',
        id: newValue?.value,
      },
    ];
   
    setData((prev) => ({
      ...prev,
      originalInvoiceNumber: newValue,
      partyInvNo:newValue?.partyInvNo,
      currency:billingCurrency,
      errorStatus: {
        ...prev.errorStatus,
        originalInvoiceNumber: false,
      },
      errorFields: {
        ...prev.errorFields,
        originalInvoiceNumber: '',
      },
    }));
    //  setInitialState((prev) => ({ //LEDX=5834
    //   ...prev,
    //   originalInvoiceNumber: newValue,
    //   partyInvNo:newValue?.partyInvNo,
    //   currency:billingCurrency,
    //   errorStatus: {
    //     ...prev.errorStatus,
    //     originalInvoiceNumber: false,
    //   },
    //   errorFields: {
    //     ...prev.errorFields,
    //     originalInvoiceNumber: '',
    //   },
    // }));

    if (arr.length > 0) {
      getLineItemDetails(arr);
    }
  };
  const handleTaxabilityChangeWrapper = (e, newValue) => {
    handleTaxabilityChange(newValue, items, nonItems);
  };


  const handleTaxabilityKeyDown = (e) => {
    let updatedTableArr = [...items];
    const zeroSalesIndex =
      updatedTableArr.findIndex((row) => row.itemCode.value === '') !== -1
        ? updatedTableArr.findIndex((row) => row.itemCode.value === '')
        : updatedTableArr.findIndex((row) => row.itemCode.value !== '');
    // const element = "itemCode" + zeroSalesIndex;
    const element = 'creditPeriod';

    const warMsg = 'Taxability is required';
    const name = 'taxability';
    const currentId = 'taxability';
    const nextId = element;
    const prevID = Type === 'DebitNote' || Type === 'CreditNote' ? 'partyNo' : 'customerOrderDate';
    const required = true;

    handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
  };
  const handleCreditPeriodChange = (e) => {
    const value = e.target.value;

    if (!/^\d*$/.test(value)) return;

    const creditPeriod = Number(value);

    if (creditPeriod > 1000) return;

    const supplierInvoiceDate = data?.customerOrderDate;
    const voucherDate = data?.invoiceDate;

    const baseDate = Type === 'Sales' || Type === 'DebitNote' || Type === 'CreditNote' ? voucherDate : supplierInvoiceDate || voucherDate;

    let dueDate = '';

    if (value !== '') {
      if (baseDate) {
        dueDate = moment(baseDate)?.add(creditPeriod, 'days').format('DD MMM YYYY');
      }
    } else {
      if (baseDate) {
        dueDate = moment(baseDate).format('DD MMM YYYY');
      }
    }

    setData((prev) => ({
      ...prev,
      creditPeriod: value,
      dueDate,
      errorStatus: {
        ...prev.errorStatus,
        creditPeriod: false,
      },
      errorFields: {
        ...prev.errorFields,
        creditPeriod: '',
      },
    }));
  };

  const handleCreditpriodKerDown = (e) => {
    let updatedTableArr = [...items];
    const zeroSalesIndex =
      updatedTableArr.findIndex((row) => row.itemCode.value === '') !== -1
        ? updatedTableArr.findIndex((row) => row.itemCode.value === '')
        : updatedTableArr.findIndex((row) => row.itemCode.value !== '');

    const element = 'itemCode' + zeroSalesIndex;
    const warMsg = `${invoiceLabels.orderDateName} is required`;
    const name = 'creditPeriod';
    const currentId = 'creditPeriod';
    const nextId = element;
    const prevID =
      Type === 'Pos'
        ? registrationType == 1
          ? 'invoiceDate'
          : 'taxability'
        : Type === 'DebitNote' || Type === 'CreditNote'
        ? registrationType == 1
          ? 'invVoucher'
          : 'taxability'
        : registrationType == 1
        ? 'customerOrderDate'
        : 'taxability';

    const required = false;

    handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
  };
  const handlePartyCategoryChange = async (partyValue) => {
    try {
      if (!partyValue) {
        setData((prev) => ({
          ...prev,
          partyName: { label: '', value: '' },
          errorStatus: { ...prev.errorStatus, partyName: true },
          errorFields: {
            ...prev.errorFields,
            partyName: invoiceLabels.partyName + ' name is required',
          },
        }));
        return;
      }
      const resPartyMaster = await API.graphql(
        graphqlOperation(getPartyMaster, {
          partyid: partyValue,
        })
      );
      if (resPartyMaster?.data?.getPartyMaster?.length > 0) {
        const partyData = resPartyMaster.data.getPartyMaster?.[0];
        let prevPlaceOfSupply = data?.placeOfSupply?.value;

        const isTaxabilityValid = data?.taxability?.value !== '';
        const isPartyCategoryValid = data?.partyCategory !== '' && data.partyCategory !== partyData?.gstcategory;

        const isCategoryMismatch =
          companyType == 3
            ? false
            : (Type === 'Sales' ? ['OC', 'SEZ'] : ['UB', 'OC', 'SEZ']).includes(data?.partyCategory) ||
              (Type === 'Sales' ? ['OC', 'SEZ'] : ['UB', 'OC', 'SEZ']).includes(partyData?.gstcategory);

        // const isInvoiceOrAmountValid = data?.originalInvoiceNumber?.length > 0 || totNetAmt > 0;
        const isInvoiceOrAmountValid = data?.originalInvoiceNumber?.value !== '' || totNetAmt > 0;
        const isPartyNameChanged = partyValue != data.partyName.value;
        const isNoteType = Type === 'DebitNote' || Type === 'CreditNote';

        const isPlaceOfSupplyChanged =
          (prevPlaceOfSupply == 96 && partyData?.placeofsupply != 96) || (partyData?.placeofsupply == 96 && prevPlaceOfSupply != 96);

        if (
          (isTaxabilityValid && isPartyCategoryValid && isCategoryMismatch) ||
          (isInvoiceOrAmountValid && isPartyNameChanged && isNoteType) ||
          (isTaxabilityValid && isPlaceOfSupplyChanged)
        ) {
          setOpenResetModal(true);
          let changeValue = {
            label: partyData?.partydisplayname,
            value: partyData?.partyid,
            type: 'party',
          };
          setNewChangeValue(changeValue);
        } else {
          let changeValue = {
            label: partyData?.partydisplayname,
            value: partyData?.partyid,
            type: 'party',
          };
          setNewChangeValue(changeValue); //fixed for place of supply [Object Object
          partyOnchange(partyData);
        }
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  };

  const partyOnchange = async (partyData) => {
    let listing = stateValue?.posListReducer?.posList?.listPlaceOfSupply;
    let statesArray = listing?.map((element) => {
      return {
        label: `(${element?.statecode})   ${element?.statename}`,

        value: element?.statecode,
      };
    });

    let partyCategory = partyData?.gstcategory || '';

    let partyAccID = partyData?.accountsid || '';
    let gstin = partyData?.relatedpartygstdetails?.[0]?.gstin || '';
    let creditLimit =
      Number(partyData?.relatedpartycreditdetails?.[0]?.creditlimitamount) > 0
        ? partyData?.relatedpartycreditdetails?.[0]?.creditlimitamount
        : 0;
    let creditPeriod = Number(partyData?.relatedpartycreditdetails?.[0]?.creditperiodduration) || 0;
    let dueDate = moment(
      data?.customerOrderDate === ''
        ? data.invoiceDate
        : Type === 'Sales' || Type === 'DebitNote' || Type === 'CreditNote' || Type === 'Pos'
        ? data?.invoiceDate
        : data?.customerOrderDate
    )?.add(creditPeriod, 'days');
    let tdsSection = partyData?.tdssection || '';
    let tdsPercentage = partyData?.tdspercentage || '';
    let billingCurrency = { label: '', value: '', sign: '', code: '' };

    const partyName = {
      label: partyData?.partydisplayname,
      value: partyData?.partyid,
      ledgerName: partyData?.accountname,
      legalName: partyData?.partylegalname,
      email: partyData?.email,
      consigneeGSTIN: partyData?.deliveryconsigneegstin,
      consigneeName: partyData?.deliveryconsigneename,
      accountsID: partyData?.accountsid,
      gstin,
      placeOfSupply: partyData?.placeofsupply,
      PartyTypeCd: partyData?.partytypecd,
      creditPeriod,
      gstCategory: partyCategory,
      billingCurrency: partyData?.relatedpartycreditdetails?.[0]?.billingcurrency,
      tdsSection,
      tdsPercentage,
      creditLimit,
    };

    const foundCurrency = billingCurrencyOptions.find(
      (currency) => currency.value === partyData?.relatedpartycreditdetails?.[0]?.billingcurrency
    );
    if (foundCurrency) {
      billingCurrency = { ...foundCurrency };
    }
    let companyState = getCompany?.relatedaddressentity?.[0]?.statecode;
    let placeOfSupply = { label: '', value: '' };
    let companyPlaceOfSupply = { label: '', value: '' };
    statesArray?.map((state) => {
      if (state.value == partyData?.placeofsupply) {
        placeOfSupply = { label: state.label, value: state.value };
      }
      if (state.value == companyState) {
        companyPlaceOfSupply = { label: state.label, value: state.value };
      }
    });
    //  placeOfSupply = partyData.deliverystatecode
    // ? { label: partyData.deliverystatename, value: partyData.deliverystatecode }
    // : companyPlaceOfSupply;

    if (partyData?.partytypecd === 'SUPPLIER' && partyCategory === 'RBCS') {
      setRegistrationType(1);
    } else {
      setRegistrationType(companyGstType);
    }
    setPartyCategery(partyCategery);
    setPartyType(partyData?.partytypecd || '');
    setPartyAccountID(partyAccID);
    displayAccountBalance(partyAccID);

    if (Type === 'CreditNote' || Type === 'DebitNote') {
      getInvoiceVouchers(partyData?.partyid, partyData?.partytypecd, data.invoiceDate);
    }

    getPartyBillAddressEntityDetails(partyData?.partyid, 'PartyBilling');
    // if (partyData?.partytypecd === "CUSTOMER") {
    getPartyDeliveryAddressDetails(partyData?.partyid, 'PartyDelivery');
    // }

    getCurrentCurrencyRate(billingCurrency.code,data?.invoiceDate);
    // if (partyData.partytypecd === 'SUPPLIER') {
    //   let prevItemCodes = itemCodes.filter((item) => item.purchase === 1);
    //   let prevItemNames = itemNames.filter((item) => item.purchase === 1);

    //   setItemNames(prevItemNames);
    //   setItemCodes(prevItemCodes);
    // }
    // if (partyData.partytypecd === 'CUSTOMER') {
    //   let prevItemCodes = itemCodes.filter((item) => item.sales === 1);
    //   let prevItemNames = itemNames.filter((item) => item.sales === 1);

    //   setItemNames(prevItemNames);
    //   setItemCodes(prevItemCodes);
    // }

    setData((prev) => ({
      ...prev,
      partyName,
      partyCategory,
      gstin,
      consigneeGST: partyData?.deliveryconsigneegstin,
      consigneeName: partyData?.deliveryconsigneename,
      partyCreditLimit: creditLimit,
      sameAsBilling:false,
      placeOfSupply:
        partyCategory === 'Overseas'
          ? { label: 'FOREIGN COUNTRY', value: 96 }
          : placeOfSupply.value !== '' && companyType !== 3
          ? placeOfSupply
          : companyPlaceOfSupply,
      creditPeriod,
      dueDate,
      currency: billingCurrency,
      tdsOptions: tdsSection,
      tdsPercent: tdsPercentage,
      errorStatus: {
        ...prev.errorStatus,
        partyName: false,
        placeOfSupply: false,
      },
      errorFields: {
        ...prev.errorFields,
        partyName: '',
        placeOfSupply: '',
      },
    }));
  };

  function changeInPlaceOfSupply(newValue) {
    if (newValue == '') {
      setData((prev) => ({
        ...prev,
        placeOfSupply: newValue,
        errorStatus: {
          ...prev.errorStatus,
          placeOfSupply: true,
        },
        errorFields: {
          ...prev.errorFields,
          placeOfSupply: Type === 'Purchase' ? 'Source Of Supply is required' : 'Place Of Supply is required',
        },
      }));
    } else {
      setData((prev) => ({
        ...prev,
        placeOfSupply: newValue,
        errorStatus: {
          ...prev.errorStatus,
          placeOfSupply: false,
        },
        errorFields: {
          ...prev.errorFields,
          placeOfSupply: '',
        },
      }));
    }
  }

  async function getLineItemDetails(arr) {
    try {
      const uniqueArr = arr.filter((item, index, self) => index === self.findIndex((t) => t.id === item.id));
      const res = await API.graphql(graphqlOperation(listLineItems, { jsondata: JSON.stringify(uniqueArr) }));
      if (res.data.listLineItems.length > 0) {
        let arr = res.data.listLineItems.map((ele) => {
          return {
            ...ele,
            invoiceid: partyType === 'SUPPLIER' ? ele.purchaseid : ele.invoiceid,
            itemNo: partyType === 'SUPPLIER' ? ele.purchaseid + ele.purchaseitemid : ele.invoiceid + ele.invoiceitemid,
          };
        });
        setPurchaseArr(arr);
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  function handleInvoiceDateChanges(value) {
    const minDate = moment(
      params?.id && !isNaN(params.id)
        ? firstInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD')
        : Type === 'DebitNote' || Type === 'Purchase' || Type === 'CreditNote'
        ? firstInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD')
        : lastInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );

    const maxDate = moment(
      params?.id && !isNaN(params.id)
        ? nextInvoiceDate || moment(endDate * 1000).format('YYYY-MM-DD')
        : moment(endDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );

    if (value === '') {
      setData((prev) => ({
        ...prev,
        invoiceDate: value,
        errorStatus: {
          ...prev.errorStatus,
          invoiceDate: true,
        },
        errorFields: {
          ...prev.errorFields,
          invoiceDate: `${invoiceLabels.dateName} is required`,
        },
      }));
      return;
    }

    const momentInvoiceDate = moment(value, 'YYYY-MM-DD');
    if (Type === 'CreditNote' || Type === 'DebitNote') {
      getInvoiceVouchers(data.partyName?.value, partyType, value);
    }
    if (
      momentInvoiceDate.isBefore(minDate) ||
      momentInvoiceDate.isAfter(maxDate)
      // &&Type === "Sales"
    ) {
      setData((prev) => ({
        ...prev,
        invoiceDate: value,
        errorStatus: {
          ...prev.errorStatus,
          invoiceDate: true,
        },
        errorFields: {
          ...prev.errorFields,
          invoiceDate: `${invoiceLabels.dateName} must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format('DD MMM YYYY')}.`,
        },
      }));
      return;
    }

    checkPriceTypeWithInvDate(value);
  //     let updatedCustomerOrderDate = data?.customerOrderDate;
  // if (
  //   data?.customerOrderDate &&
  //   moment(value).isBefore(moment(data.customerOrderDate, 'YYYY-MM-DD'))
  // ) {
  //   updatedCustomerOrderDate = '';

  // }

    let baseDate =
  data?.customerOrderDate === ''
    ? moment(value)
    : Type === 'Sales' || Type === 'DebitNote' || Type === 'CreditNote' || Type === 'Pos'
    ? moment(value)
    : moment(data?.customerOrderDate);

let dueDate = baseDate
  .add(data?.creditPeriod || 0, 'days')
  .format('DD MMM YYYY');

    getCurrentCurrencyRate(data?.currency?.code,value);
    setData((prev) => ({
      ...prev,
      invoiceDate: value,
      dueDate: dueDate,
      // customerOrderDate:updatedCustomerOrderDate,
      // dateOfDispatch: value,
      errorStatus: {
        ...prev.errorStatus,
        invoiceDate: false,
        dueDate: false,
        dateOfDispatch: false,
      },
      errorFields: {
        ...prev.errorFields,
        invoiceDate: '',
        dueDate: '',
        dateOfDispatch: '',
      },
    }));
  }
  function checkPriceTypeWithInvDate(value) {
    const updatedTableArr = [...items];
    let isValid = true;

    const momentInvoiceDate = moment(value, 'YYYY-MM-DD');
    updatedTableArr.forEach((subele) => {
      if (subele?.effectiveFrom !== 0) {
        const tempEffectiveFrom = moment(subele.effectiveFrom * 1000).startOf('day');
        const tempEffectiveTo =
          subele.effectiveTo === '' || subele?.effectiveTo === 0 ? null : moment(subele.effectiveTo * 1000).startOf('day');

        const normalizedInvoiceDate = moment(momentInvoiceDate).startOf('day');
        const isOutsideRange =
          normalizedInvoiceDate.isBefore(tempEffectiveFrom) || (tempEffectiveTo && normalizedInvoiceDate.isAfter(tempEffectiveTo));

        if (isOutsideRange) {
          isValid = false;
          subele.invalidDate = true;
        } else {
          subele.invalidDate = false;
        }
      }
    });

    if (!isValid) {
      showWarningSnackbar('The highlighted items do not match the invoice date range. Please verify the effective dates.');
    }
  }
  const handleInvoiceDateBlur = (e) => {
  const value = e.target.value;
  let updatedCustomerOrderDate = data?.customerOrderDate;
  if (
    data?.customerOrderDate &&
    moment(value).isBefore(moment(data.customerOrderDate, 'YYYY-MM-DD'))
  ) {
    updatedCustomerOrderDate='';
  }
    setData((prev) => ({
      ...prev,
   customerOrderDate:updatedCustomerOrderDate
}));
  setInitialState((prev) => ({
      ...prev,
   customerOrderDate:updatedCustomerOrderDate
}));
  };

  let dispatch = useDispatch();
  useEffect(() => {
    if ((stateValue?.posListReducer.posList.listPlaceOfSupply?.length ?? 0) === 0) {
      dispatch(fetchPosList());
    }
    getCompanyDetails();
    listUserPreferenceData();
  }, []);
  useEffect(() => {
    if (stateValue.posListReducer.posList.length !== 0) {
      getStates();
    }
    return () => {};
  }, [stateValue]);

  useEffect(() => {
    getInitialStates();
  }, [companyData, listOfStates]);
  useEffect(() => {
    if (invoiceEntry?.length !== 0) {
      getInvoiceBasicDetails(invoiceEntry);
    }
  }, [invoiceEntry]);
  useEffect(() => {
    listPartyDetails('', 0, 20);
  }, []);

  function handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID, multiple) {
    const activeDescendantId = e.target.getAttribute('aria-activedescendant');
    const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';

    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
      if (multiple && e.key === 'Enter') {
        return; // Exit without moving focus to next field
      }

      if (
        required &&
        (e.target.value === '' || e.target.value === undefined || e.target.value === 0) &&
        isAutocompleteOpen &&
        !activeDescendantId
      ) {
        e.preventDefault();
        e.stopPropagation();
        setData((prev) => ({
          ...prev,
          [name]: '',
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: warMsg,
          },
        }));
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  function handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID, momentInvoiceDate, invoiceLabels) {
    const minDate = moment(
      params?.id && !isNaN(params.id)
        ? firstInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD')
        : lastInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );

    const maxDate = moment(
      params?.id && !isNaN(params.id)
        ? nextInvoiceDate || moment(endDate * 1000).format('YYYY-MM-DD')
        : moment(endDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );

    if (e.key === 'Tab' && e.shiftKey) {
      e?.preventDefault();
      e?.stopPropagation();

      document.getElementById(prevID)?.focus();
      return;
    }

    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
      if (
        (name === 'invoiceDate' &&
          (moment(e?.target?.value, 'YYYY-MM-DD').isBefore(minDate) || moment(e?.target?.value, 'YYYY-MM-DD').isAfter(maxDate))) ||
        data?.invoiceDate === ''
      ) {
        e?.preventDefault();
        e?.stopPropagation();
        document.getElementById(currentId)?.focus();
        return;
      } else if (name === 'customerOrderDate' && moment(e?.target?.value, 'YYYY-MM-DD').isAfter(data?.invoiceDate)) {
        e?.preventDefault();
        e?.stopPropagation();
        document.getElementById(currentId)?.focus();
      } else {
        e?.preventDefault();
        e?.stopPropagation();

        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }

  // useEffect(() => {
  //   if (
  //     Number(totNetAmt) > 0 &&
  //     Number(data.partyCreditLimit) > 0 &&
  //     Number(totNetAmt) + Number(accountBalance?.accBal) > Number(data.partyCreditLimit)
  //   ) {
  //     showWarningSnackbar("The Net Amount exceeds the party's Credit Limit");
  //   }
  // }, [totNetAmt, data.partyCreditLimit, accountBalance]);

useEffect(() => {
  const handler = setTimeout(() => {
    const skipValidation =
      (Type === "CreditNote" && partyType === "CUSTOMER") ||
      (Type === "DebitNote" && partyType === "SUPPLIER");

    if (
      !skipValidation &&
      Number(totNetAmt) > 0 &&
      Number(data.partyCreditLimit) > 0 &&
      Number(totNetAmt) + Number(accountBalance?.accBal) > Number(data.partyCreditLimit)
    ) {
      showWarningSnackbar("The Net Amount exceeds the party's Credit Limit");
    }
  }, 800);

  return () => clearTimeout(handler); // clear if user types again
}, [totNetAmt, data.partyCreditLimit, accountBalance, Type, partyType]);


  // const handleTaxabilityChange = (newValue, items, nonItems) => {
  //   if (newValue === "") {
  //     setData((prev) => ({
  //       ...prev,
  //       errorStatus: {
  //         ...prev.errorStatus,
  //         taxability: true,
  //       },
  //       errorFields: {
  //         ...prev.errorFields,
  //         taxability: "Taxability is required",
  //       },
  //     }));
  //     return;
  //   }
  //   if (newValue?.value == 6 && data?.partyCategory === "SEZ") {
  //     setCompanyState("");
  //   } else {
  //     setCompanyState(companyPlaceofState?.value);
  //   }
  //   setData((prev) => ({
  //     ...prev,
  //     reverseChargeFlag: newValue?.value === 4 ? 1 : 0,
  //   }));

  //   if (totNetAmt) {
  //     let updatedItems = items.map((ele) => ({
  //       ...ele,
  //       originalIGST: ele.originalIGST ?? ele.IGST,
  //       originalGSTCess: ele.originalGSTCess ?? ele.GSTCess,
  //       originalNetAmt:
  //         companyType === 3
  //           ? ele.originalTaxAmt ?? ele.taxableAMount
  //           : ele.originalNetAmt ?? ele.netAmount,
  //       originalTaxAmt: ele.originalTaxAmt ?? ele.taxableAMount,
  //     }));

  //     updatedItems = updatedItems.map((ele) => {
  //       if (
  //         newValue.value === 4 &&
  //         (partyType === "CUSTOMER" || Type === "Pos")
  //       ) {
  //         let igstAmt = 0;
  //         igstAmt = (Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100;
  //         igstAmt = Number(igstAmt) / 2;
  //         igstAmt = Math.round(igstAmt * 100) / 100;
  //         igstAmt = igstAmt * 2;

  //         return {
  //           ...ele,
  //           IGST: igstAmt,
  //           //  ((Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100 / 2) * 2,
  //           GSTCess: ele.originalGSTCess,
  //           netAmount: ele.taxableAMount,
  //         };
  //       } else if ([2, 3, 5, 7, 9].includes(newValue.value)) {
  //         return {
  //           ...ele,
  //           IGST: 0,
  //           GSTCess: 0,
  //           netAmount: ele.taxableAMount,
  //         };
  //       } else {
  //         let igstAmt = 0;
  //         igstAmt = (Number(ele.originalTaxAmt) * Number(ele.GSTRate)) / 100;
  //         igstAmt = Number(igstAmt) / 2;
  //         igstAmt = Math.round(igstAmt * 100) / 100;
  //         igstAmt = igstAmt * 2;
  //         return {
  //           ...ele,
  //           IGST: igstAmt,
  //           // ((Number(ele.originalTaxAmt) * Number(ele.GSTRate)) / 100 / 2) * 2,
  //           GSTCess: ele.originalGSTCess,
  //           taxableAMount: ele.originalTaxAmt,
  //           netAmount:
  //             companyType === 3
  //               ? Number(ele.originalTaxAmt)
  //               : Number(ele.originalTaxAmt) +
  //                 Number(ele.originalGSTCess) +
  //                 igstAmt,
  //           // Number(((Number(ele.originalTaxAmt) * Number(ele.GSTRate)) / 100 / 2) * 2),
  //         };
  //       }
  //     });

  //     let updatedNonItems = nonItems.map((ele) => ({
  //       ...ele,
  //       originalIGST: ele.originalIGST ?? ele.IGST,
  //       originalGSTCess: ele.originalGSTCess ?? ele.GSTCess,
  //       originalNetAmt:
  //         companyType === 3
  //           ? ele.originalTaxAmt ?? ele.taxableAMount
  //           : ele.originalNetAmt ?? ele.netAmount,
  //       originalTaxAmt: ele.originalTaxAmt ?? ele.taxableAMount,
  //     }));

  //     updatedNonItems = updatedNonItems.map((ele) => {
  //       if (
  //         newValue.value === 4 &&
  //         (partyType === "CUSTOMER" || Type === "Pos")
  //       ) {
  //         let igstAmt = 0;
  //         igstAmt = (Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100;
  //         igstAmt = Number(igstAmt) / 2;
  //         igstAmt = Math.round(igstAmt * 100) / 100;
  //         igstAmt = igstAmt * 2;
  //         return {
  //           ...ele,
  //           IGST: igstAmt,
  //           //  ((Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100 / 2) * 2,
  //           GSTCess: ele.originalGSTCess,
  //           netAmount: ele.taxableAMount,
  //         };
  //       } else if ([2, 3, 5, 7, 9].includes(newValue.value)) {
  //         return {
  //           ...ele,
  //           IGST: 0,
  //           GSTCess: 0,
  //           netAmount: ele.taxableAMount,
  //         };
  //       } else {
  //         let igstAmt = 0;
  //         igstAmt = (Number(ele.originalTaxAmt) * Number(ele.GSTRate)) / 100;
  //         igstAmt = Number(igstAmt) / 2;
  //         igstAmt = Math.round(igstAmt * 100) / 100;
  //         igstAmt = igstAmt * 2;
  //         return {
  //           ...ele,
  //           IGST: igstAmt,
  //           //  ((Number(ele.originalTaxAmt) * Number(ele.GSTRate)) / 100 / 2) * 2,
  //           GSTCess: ele.originalGSTCess,
  //           taxableAMount: ele.originalTaxAmt,
  //           netAmount:
  //             companyType === 3
  //               ? Number(ele.originalTaxAmt)
  //               : Number(ele.originalTaxAmt) +
  //                 Number(ele.originalGSTCess) +
  //                 igstAmt,
  //           // Number(((Number(ele.originalTaxAmt) * Number(ele.GSTRate)) / 100 / 2) * 2),
  //         };
  //       }
  //     });

  //     setNonItems(updatedNonItems);
  //     setItems(updatedItems);
  //   }

  //   setData((prev) => ({
  //     ...prev,
  //     taxability: newValue,
  //     errorStatus: {
  //       ...prev.errorStatus,
  //       taxability: false,
  //     },
  //     errorFields: {
  //       ...prev.errorFields,
  //       taxability: "",
  //     },
  //   }));
  // };
  const handleTaxabilityChange = (newValue, items, nonItems) => {
    if (newValue === '') {
      setData((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          taxability: true,
        },
        errorFields: {
          ...prev.errorFields,
          taxability: 'Taxability is required',
        },
      }));
      return;
    }

    if (newValue?.value == 6 && data?.partyCategory === 'SEZ') {
      setCompanyState('');
    } else {
      setCompanyState(companyPlaceofState?.value);
    }

    setData((prev) => ({
      ...prev,
      reverseChargeFlag: newValue?.value === 4 ? 1 : 0,
    }));

    if (totNetAmt) {
      // Update Items
      let updatedItems = [...items];

      updatedItems = updatedItems.map((ele) => ({
        ...ele,
        originalGSTRate: ele.GSTRate,
        originalCessRate: ele.cessRate,
        originalIGST: ele.IGST,
        originalGSTCess: ele.GSTCess,
        originalNetAmt: companyType === 3 && partyType === 'CUSTOMER' ? ele.taxableAMount : ele.netAmount, //LEDX-4673
        originalTaxAmt: ele.taxableAMount,
      }));

      updatedItems = updatedItems.map((ele) => {
        if (newValue.value === 4 && (partyType === 'CUSTOMER' || Type === 'Pos')) {
          let igstAmt = 0;
          if(ele?.manualGSTFlag===0){
          if(Number(ele.GSTRate)>0){
          igstAmt = (Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100;
          igstAmt = Number(igstAmt) / 2;
          igstAmt = Math.round(igstAmt * 100) / 100;
          igstAmt = igstAmt * 2;
          }
        }else{
          igstAmt=ele?.IGST;
        }
         let cessAmt=0;
         if(ele?.manualCess===0){
          if(Number(ele.cessRate)>0){
          cessAmt = (Number(ele.taxableAMount) * Number(ele.cessRate)) / 100;
          cessAmt=Number(Number(cessAmt).toFixed(2));
        
          }
        }else{
          cessAmt=ele?.GSTCess;
           cessAmt=Number(Number(cessAmt).toFixed(2));
        }
          return {
            ...ele,
            IGST: igstAmt,
            // GSTCess: ele.originalGSTCess,
            GSTCess:cessAmt,//LEDX-5418
            netAmount: ele.taxableAMount,
          };
        } else if ([2, 3, 5, 7, 9].includes(newValue.value)) {
          return {
            ...ele,
            IGST: 0,
            GSTCess: 0,
            netAmount: ele.taxableAMount,
          };
        }
        
        else {
          let igstAmt = 0;
          if(ele?.manualGSTFlag===0){
          if(Number(ele.originalGSTRate)>0){
          igstAmt = (Number(ele.originalTaxAmt) * Number(ele.originalGSTRate)) / 100;
          igstAmt = Number(igstAmt) / 2;
          igstAmt = Math.round(igstAmt * 100) / 100;
          igstAmt = igstAmt * 2;
          }
        }else{
          igstAmt=ele?.IGST;
        }
         let cessAmt=0;
         if(ele?.manualCess===0){
          if(Number(ele.originalCessRate)>0){
          cessAmt = (Number(ele.originalTaxAmt) * Number(ele.originalCessRate)) / 100;
           cessAmt=Number(Number(cessAmt).toFixed(2));
        
          }
        }else{
           cessAmt=Number(Number(cessAmt).toFixed(2));
        }
          return {
            ...ele,
            IGST: igstAmt,
            GSTRate: ele.originalGSTRate,
            cessRate:ele.originalCessRate,
            // GSTCess: ele.originalGSTCess,
            GSTCess:cessAmt,//LEDX-5418
            taxableAMount: ele.originalTaxAmt,
            netAmount:
              //LEDX-4673
              companyType === 3 && partyType === 'CUSTOMER'
                ? Number(ele.originalTaxAmt)
                : Number(ele.originalTaxAmt) +
                //  Number(ele.originalGSTCess)
                Number(cessAmt)//LEDX-5418
                  + Number(igstAmt),
          };
        }
      });

      // Update Non-Items
      let updatedNonItems = [...nonItems];
      updatedNonItems = updatedNonItems.map((ele) => ({
        ...ele,
        originalGSTRate: ele.GSTRate,
        originalIGST: ele.IGST,
        originalCessRate:ele?.cessRate,
        originalGSTCess: ele.GSTCess,
        originalNetAmt: companyType === 3 && partyType === 'CUSTOMER' ? ele.taxableAMount : ele.netAmount, //LEDX-4673
        originalTaxAmt: ele.taxableAMount,
      }));

      updatedNonItems = updatedNonItems.map((ele) => {
        if (newValue.value === 4 && (partyType === 'CUSTOMER' || Type === 'Pos')) {
          let igstAmt = 0;
           if(ele?.manualGSTFlag===0){
          if(Number(ele?.GSTRate)>0){
          igstAmt = (Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100;
          igstAmt = Number(igstAmt) / 2;
          igstAmt = Math.round(igstAmt * 100) / 100;
          igstAmt = igstAmt * 2;
          }
        }else{
          igstAmt=ele?.IGST;
        }
        let cessAmt=0;
         if(ele?.manualCess===0){
          
          if(Number(ele.cessRate)>0){
          cessAmt = (Number(ele.taxableAMount) * Number(ele.cessRate)) / 100;
          cessAmt=Number(Number(cessAmt).toFixed(2));
        
          }
        }else{
          cessAmt=ele?.GSTCess;
           cessAmt=Number(Number(cessAmt).toFixed(2));
        }
          return {
            ...ele,
            IGST: igstAmt,
            // GSTCess: ele.originalGSTCess,
            GSTCess:cessAmt,//LEDX-5418
            netAmount: ele.taxableAMount,
          };
        } else if ([2, 3, 5, 7, 9].includes(newValue.value)) {
          return {
            ...ele,
            IGST: 0,
            GSTCess: 0,
            netAmount: ele.taxableAMount,
          };
        }
        else {
          let igstAmt = 0;
             if(ele?.manualGSTFlag===0){
          if(Number(ele?.GSTRate)>0){
          igstAmt = (Number(ele.originalTaxAmt) * Number(ele.GSTRate)) / 100;
          igstAmt = Number(igstAmt) / 2;
          igstAmt = Math.round(igstAmt * 100) / 100;
          igstAmt = igstAmt * 2;
          }
        }else{
          igstAmt=ele?.IGST;
        }
        let cessAmt=0;
         if(ele?.manualCess===0){
          if(Number(ele.originalCessRate)>0){
          cessAmt = (Number(ele.originalTaxAmt) * Number(ele.originalCessRate)) / 100;
          cessAmt=Number(Number(cessAmt).toFixed(2));
        
          }
        }else{
          cessAmt=ele?.GSTCess;
           cessAmt=Number(Number(cessAmt).toFixed(2));
        }
          return {
            ...ele,
            IGST: igstAmt,
            GSTRate: ele.originalGSTRate,
            cessRate:ele.originalCessRate,
            // GSTCess: ele.originalGSTCess,
            GSTCess:cessAmt,//LEDX-5418
            taxableAMount: ele.originalTaxAmt,
            netAmount:
              //LEDX-4673
              companyType === 3 && partyType === 'CUSTOMER'
                ? Number(ele.originalTaxAmt)
                : Number(ele.originalTaxAmt) + 
                // Number(ele.originalGSTCess)
                Number(cessAmt)//LEDX-5418
                 + Number(igstAmt),
          };
        }
      });

      setItems(updatedItems);
      setNonItems(updatedNonItems);
    }
    
    if(Number(voucherFlag)!==-1 && Type==="Sales"){
    // handleVoucherByTaxability(newValue?.value);
    if (data?.taxability?.value===""||
  ([2, 3, 5, 7, 9].includes(newValue?.value) !==
  [2, 3, 5, 7, 9].includes(Number(data?.taxability?.value)))
) {
  handleVoucherByTaxability(newValue?.value);
}

    }
    setData((prev) => ({
      ...prev,
      taxability: newValue,
      taxType:(Type==="Sales" &&[2, 3, 5, 7, 9].includes(newValue?.value))|| Number(companyType)===3?3:1,
      errorStatus: {
        ...prev.errorStatus,
        taxability: false,
      },
      errorFields: {
        ...prev.errorFields,
        taxability: '',
      },
    }));
  };
//   function handleVoucherByTaxability(taxVal) {
//   if (!activeVouchers?.length) return;

//   const isSalesOrPos = Type === "Sales" || Type === "Pos";
 
//   const preferByFlag = isSalesOrPos && [2, 3, 5].includes(taxVal);

//   const toLabel = (v) => `${v?.prefix ?? ""}${v?.nextinvoicenumber ?? ""}${v?.suffix ?? ""}`;
//   const pickedVoucher =
//     (preferByFlag && activeVouchers.find((v) => v.serialflag === 1)) ||
//      activeVouchers.find(v => v.secondlastused === 1) ||activeVouchers.find(v => v.lastused === 1)|| activeVouchers[0];

//   const voucherNumber = pickedVoucher ? toLabel(pickedVoucher) : "";
//   const selectedOption = pickedVoucher
//     ? { label: voucherNumber, value: pickedVoucher.serialnumber }
//     : { label: "", value: "" };

//   setData((p) => ({ ...p, voucherNumber, seriesVouchers: selectedOption }));
//   setInitialState?.((p) => ({ ...p, voucherNumber, seriesVouchers: selectedOption }));
// }
 function handleVoucherByTaxability(taxVal) {
  if (!activeVouchers?.length) return;

  const isSalesOrPos = Type === "Sales" || Type === "Pos";
  const isSerialFlag=data?.seriesVouchers?.serialflag;
 
  const preferByFlag = isSalesOrPos && [2, 3, 5,7,9].includes(taxVal);
  const toLabel = (v) => `${v?.prefix ?? ""}${v?.nextinvoicenumber ?? ""}${v?.suffix ?? ""}`;
    
    const pickedVoucher =
    // (preferByFlag && activeVouchers.find((v) => v.serialflag === 1)) 
    (preferByFlag ? activeVouchers.find((v) => v.serialflag === 1):(activeVouchers.find((v) => v.serialflag === 0))) ||(
    (activeVouchers.find((v) => v.serialflag === 1 && v.lastused===1)? activeVouchers.find(v => v.secondlastused === 1):activeVouchers.find(v => v.lastused === 1)) ||activeVouchers.find(v => v.lastused === 1)|| activeVouchers[0]);

  const voucherNumber =!params?.id?(pickedVoucher ? toLabel(pickedVoucher) : ""):(preferByFlag ? toLabel(pickedVoucher):invoiceEntry?.invoicenumber);
  const selectedOption =!params?.id?(pickedVoucher
    ? { label: voucherNumber, value: pickedVoucher.serialnumber,serialflag:pickedVoucher?.serialflag }
    : { label: "", value: "",serialflag:0 }):(preferByFlag?
     { label: voucherNumber, value: pickedVoucher.serialnumber,serialflag:pickedVoucher?.serialflag }:{ label: voucherNumber, value: invoiceEntry.serialnumber,serialflag:invoiceEntry?.serialflag });
  if(Number(isSerialFlag)===Number(pickedVoucher.serialflag)){
    return;
  }
  setData((p) => ({ ...p, voucherNumber, seriesVouchers: selectedOption }));
  setInitialState?.((p) => ({ ...p, voucherNumber, seriesVouchers: selectedOption }));
}
const handleITCFlag=(value)=>{
  setData((prev)=>({
    ...prev,
    ITCFlag:value?1:0
  }));
  setInitialState((prev)=>({
    ...prev,
    ITCFlag:value?1:0
  }));
};

  return (
    <Box className={params?.view === true ? 'disable-interactions !mportant' : ''}>
      <Box
        sx={{
          m: 1,
          marginLeft: '0px',
          display: 'flex',
          alignItems: { sm: 'center' },
          flexWrap: { xs: 'wrap', md: 'nowrap' },
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        <Grid container spacing={2}>
          <Grid item lg={2} xs={12}>
            <Autocomplete
              disableClearable
              openOnFocus={params?.view === true || params?.id ? false : true}
              autoFocus
              disablePortal
              id="partyName"
              options={
                Type === 'Purchase'
                  ? ['Add Supplier', ...partyNameOptions.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))]
                  : Type === 'Sales'
                  ? ['Add Customer', ...partyNameOptions.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))]
                  : ['Add Party', ...partyNameOptions.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))]
              }
              onChange={handlePartyChange}
              // ListboxProps={ListboxProps}
                                        ListboxProps={{
  sx: {
     '& .MuiAutocomplete-option': {
        paddingTop: '3px !important',
        paddingBottom: '3px !important',
        minHeight: '25px !important',
      },
  },
}}
              PaperComponent={PaperComponent}
              onKeyDown={(e) => {
                const value = e.target.value;
                if (value !== 'Add Customer' || value !== 'Add Supplier' || value !== 'Add Party') {
                  const warMsg = `${invoiceLabels.partyName}` + ' ' + 'is required ';
                  const name = 'partyName';
                  const currentId = 'partyName';
                  const nextId = value === '' ? 'partyName' : companyType == 3 ? 'voucher' : 'placeOfSupply';
                  const prevID = '';
                  const required = true;
                  handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
                }
              }}
              onInputChange={(e, newValue) => {
                setPartyRowFrom(0);
                if (newValue) {
                  listPartyDetails(newValue, 0, 20);
                } else {
                  listPartyDetails('', 0, 20);
                }
              }}
 
              clearIcon={data.partyName?.value !== '' ? <ClearIcon style={{ fontSize: '20px' }} /> : null}
              value={data.partyName}
              isOptionEqualToValue={(option, value) => option.value === value?.value}
              renderOption={(props, option) => (
                <>
                  {option === (Type === 'Purchase' ? 'Add Supplier' : Type === 'Sales' ? 'Add Customer' : 'Add Party') ? (
                    <MenuItem
                      value={'addparty'}
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        setPartyParamsID('');
                        setNewPartyID('');
                        // if (Type === "DebitNote" || Type === "CreditNote") {
                        setPartyType(Type === 'Sales' || Type === 'CreditNote' ? 'CUSTOMER' : 'SUPPLIER');
                        // }
                        setOpenPartyModal(true);
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        position: 'sticky',
                        // bottom: "-7.5px",
                        mt: '-8px !important',
                        top: '-8px !important',
                        zIndex: 1,
                        backgroundColor: grey[50],
                        '&:hover': {
                          backgroundColor: grey[200],
                        },
                      }}
                    >
                      <AddBox
                        fontSize="small"
                        sx={{
                          marginRight: '5px',
                          color: 'primary.main',
                        }}
                      />
                      <ListItemText
                        sx={{ color: 'primary.main' }}
                        primary={Type === 'Purchase' ? 'Add Supplier' : Type === 'Sales' ? 'Add Customer' : 'Add Party'}
                      />
                    </MenuItem>
                  ) : (
                    <li {...props}>
                      {' '}
            <Box
  sx={{
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }}
title={`${option.label} ${
      Type === 'DebitNote' || Type === 'CreditNote'
        ? `(${option?.PartyTypeCd === 'SUPPLIER' ? 'Trade Payables' : 'Trade Receivables'})`
        : ''
    }`}
>
 <Typography component="span" sx={{ fontSize: "14px", lineHeight: '20px', fontWeight: 400 }}>
  {option.label}
</Typography>

{(Type === "DebitNote" || Type === "CreditNote") && (
 <Typography
  component="span"
  sx={{ fontSize: "14px", fontWeight: 400, ml: 0.5, fontStyle: "italic",lineHeight: '20px' }}
>
  ({option?.PartyTypeCd === "SUPPLIER" ? "Trade Payables" : "Trade Receivables"})
</Typography>

)}

</Box>

                    </li>
                  )}
                </>
              )}
              size="small"
              renderInput={(params) => (
                <TextField
                  //

                  required={true}
                  error={data.errorStatus.partyName === true ? true : false}
                  sx={{
                    '.MuiFormLabel-root': {
                      fontSize: {
                        xs: '12px', // Small screens
                        sm: '14px', // Medium screens
                        md: '16px', // Large screens
                      },
                      maxWidth: 'calc(100% - 40px)', // Prevent label overflow
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    },
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: {
                        xs: '10px',
                        sm: '12px',
                        md: '14px',
                      },
                      fontWeight: 'bold',
                      marginLeft: '2px',
                    },
                    '.MuiOutlinedInput-root': {
                      paddingRight: '35px', // Ensures dropdown icon doesn't overlap text
                    },
                    '.MuiInputBase-input': {
                      paddingRight: '40px !important', // Extra spacing for text
                    },
                  }}
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: params?.id && invoiceEntry?.partyisactive != 0 && (
                      <>
                        <LabelIcon
                          value={data.partyName.value}
                          params={params.InputProps.endAdornment}
                          setOpen={setOpenPartyModal}
                          setParamsID={setPartyParamsID}
                          editMode={true}
                          type="Accounts"
                        />
                      </>
                    ),
                  }}
                  label={invoiceLabels.partyName}
                />
              )}
            />

            <Typography
              sx={{
                marginTop: '2px',
                marginLeft: '10px',
                marginBottom: '0px',
                fontSize: '11px',
                color: 'danger.main',
              }}
            >
              {data?.errorFields.partyName}
            </Typography>

            {data.errorStatus.partyName == false && data.partyName.label !== '' && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column', // stack vertically
                  width: '100%',
                  alignItems: 'flex-start', // align text to left
                }}
              >
                {/* Line 1: Party Type */}
                <Typography
                  tabIndex={0}
                  sx={{
                    fontSize: '13px',
                    whiteSpace: 'nowrap',
                    color: 'rgb(29, 121, 255) !important',
                    textDecoration: 'none !important',
                  }}
                >
                  {data?.partyCategory === 'RBR'
                    ? 'Registered'
                    : data?.partyCategory === 'UB'
                    ? 'Unregistered'
                    : data?.partyCategory === 'SEZ'
                    ? 'SEZ'
                    : data?.partyCategory === 'RBCS'
                    ? 'Composition'
                    : 'Overseas'}
                </Typography>

                {/* Line 2: Balance link */}
                {Number(accountBalance?.accBal) !== 0 && (
                  <a
                    href={`/LedgerTransactions/${partyAccountID}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="myLink"
                    style={{
                      fontSize: '14px',
                      pointerEvents: 'auto !important',
                      cursor: 'pointer !important',
                      color: '#1D79FF',
                      textDecoration: 'underline',
                    }}
                  >
                    <Typography
                      tabIndex={0}
                      sx={{
                        fontSize: '13px',
                        whiteSpace: 'nowrap',
                        color: 'rgb(29, 121, 255) !important',
                        textDecoration: 'underline !important',
                        pointerEvents: 'auto !important',
                        cursor: 'pointer !important',
                      }}
                    >
                      ₹ {formatNumber(accountBalance?.accBal || 0, true, true, accountBalance?.balSign)}
                    </Typography>
                  </a>
                )}
              </div>
            )}
          </Grid>
          {registrationType !== 1 && (
            <Grid item lg={2} xs={12}>
              <TextField
                value={
                  data.gstin === '' ? (data?.partyCategory === 'UB' ? '-----' : data?.partyCategory === 'OC' ? '-----' : '') : data.gstin
                }
                required={['UB', 'RBCS', 'OC'].includes(data?.partyCategory) ? false : true}
                label={invoiceLabels.gstINName}
                disabled={true}
                size="small"
                fullWidth
                onChange={handleGSTINChange}
                InputProps={{
                  endAdornment: partyCategery !== 'UB' && <LabelIcon value={data.gstin} type="text" editMode={false} />,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
              />
            </Grid>
          )}
          <AddressDetails
            data={data}
            stateArr={stateArr}
            countryArr={countryArr}
            districtArr={districtArr}
            cityArr={cityArr}
            stateName={stateName}
            districtName={districtName}
            countryName={countryName}
            stateDelName={stateDelName}
            districtDelName={districtDelName}
            countryDelName={countryDelName}
            partyBillAddressEntity={partyBillAddressEntity}
            deliveryAddressDetails={deliveryAddressDetails}
            billingAddressDetails={billingAddressDetails}
            partyDeliveryAddressEntity={partyDeliveryAddressEntity}
            setBillingAddressDetails={setBillingAddressDetails}
            setDeliveryAddressDetails={setDeliveryAddressDetails}
            setStateArr={setStateArr}
            setDistrictArr={setDistrictArr}
            setCityArr={setCityArr}
            setCountryArr={setCountryArr}
            partyID={data.partyName.value}
            registrationType={registrationType}
            partyType={partyType}
            setData={setData}
            invoiceEntry={invoiceEntry}
            Type={Type}
            partyCategery={partyCategery}
            getPartyDeliveryAddressDetails={getPartyDeliveryAddressDetails}
          />
        </Grid>
      </Box>

      <Box
        sx={{
          m: 1,
          marginLeft: '0px',
          display: 'flex',
          alignItems: { sm: 'center' },
          flexWrap: { xs: 'wrap', md: 'nowrap' },
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        <Grid container spacing={2} sx={{ paddingTop: '5px' }}>
          <Grid item lg={2} xs={12} md={4}>
            <Autocomplete
              openOnFocus
              disableClearable
              disablePortal
              id="placeOfSupply"
              options={listOfStates}
              disabled={data.partyName.value === '' || companyData?.relatedcompanydetailsnew?.[0].registrationtype == 3 ? true : false}
              value={data.placeOfSupply}
              isOptionEqualToValue={(option, value) => option.value === value?.value}
              onChange={handlePlaceOfSupplyChange}
              onKeyDown={handlePlaceOfSupplyKeyDown}
              size="small"
              renderInput={(params) => (
                <TextField
                  required={true}
                  error={data.errorStatus.placeOfSupply === true ? true : false}
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontWeight: 'bold',
                      fontSize: '16px',
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        <LabelIcon
                          value={data.placeOfSupply.value}
                          params={params.InputProps.endAdornment}
                          editMode={false}
                          type="Accounts"
                        />
                      </>
                    ),
                  }}
                  label={Type == 'Purchase' ? 'Source Of Supply' : 'Place Of Supply'}
                />
              )}
            />
            <Typography
              sx={{
                marginTop: '2px',
                marginLeft: '10px',
                marginBottom: '0px',
                fontSize: '11px',
                color: 'danger.main',
              }}
            >
              {data?.errorFields.placeOfSupply}
            </Typography>
          </Grid>
          <VoucherComponent
            data={data}
            setData={setData}
            setInitialState={setInitialState}
            invoiceLabels={invoiceLabels}
            todayDate={todayDate}
            voucherArr={voucherArr}
            setVoucherArr={setVoucherArr}
            params={params}
            Type={Type}
            invoiceEntry={invoiceEntry}
            companyData={companyData}
            next={'currency'}
          />
          <Grid item lg={2} xs={12} md={12}>
            <Autocomplete
              openOnFocus
              disablePortal
              disabled={data.partyName.value === '' || invoiceEntry?.length !== 0}
              id="currency"
              options={
                showAllCurrencies === true
                  ? [...billingCurrencyOptions, 'Show All Currencies']
                  : [...billingCurrencyOptions.slice(0, 10), 'Show All Currencies']
              }
              disableClearable
              value={data.currency}
              isOptionEqualToValue={(option, value) => option?.value === value?.value}
              onChange={handleCurrencyChange}
              onKeyDown={handleCurrencyKeyDown}
              size="small"
              renderOption={(props, option) => {
                if (option === 'Show All Currencies') {
                  return (
                    <MenuItem
                      key={option.value}
                      value={'showAllCurrencies'}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (showAllCurrencies === false) {
                          setShowAllCurrencies(true);
                        } else {
                          setShowAllCurrencies(false);
                        }
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        position: 'sticky',
                        bottom: '0px',
                        zIndex: 1,
                        ml: '-10px',
                        backgroundColor: grey[50],
                        '&:hover': {
                          backgroundColor: grey[200],
                        },
                      }}
                    >
                      <Checkbox
                        checked={showAllCurrencies}
                        fontSize="small"
                        sx={{
                          marginRight: '5px',
                          color: 'primary.main',
                        }}
                        onClick={toggleShowAllCurrencies}
                      />
                      <ListItemText sx={{ color: 'primary.main' }} primary={'Show All Currencies'} />
                    </MenuItem>
                  );
                }
                return (
                  <li {...props} key={option.value}>
                    {option.label}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  required
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '16px',
                      fontWeight: 'bold',
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...params}
                  label="Billing Currency"
                />
              )}
            />

            <Typography
              sx={{
                marginTop: '2px',
                marginLeft: '10px',
                marginBottom: '0px',
                fontSize: '11px',
                color: 'danger.main',
              }}
            >
              {data?.errorFields.currency}
            </Typography>
          </Grid>
          {data.currency.code !== 'INR' && (
            <Grid item lg={1} xs={12} md={12}>
              <TextField
                error={data.errorStatus.currencyRate === true ? true : false}
                label="Currency Rate"
                size="small"
                id="currencyRate"
                name="currencyRate"
                required={data.currencyRate === '' || data.currencyRate === 0 ? true : false}
                value={data.currencyRate}
                type="text"
                onChange={handleCurrencyRateChange}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  maxWidth: 180,
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CurrencyRupeeIcon fontSize="14px" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          )}
          <Grid item lg={data.currency.code === 'INR' ? 2 : 1.5} xs={12} md={12}>
            <TextField
              error={data.errorStatus.invoiceDate === true}
              disabled={data.partyName.value === ''}
              name="invoiceDate"
              id="invoiceDate"
              label={invoiceLabels.dateName}
              variant="outlined"
             
              size="small"
              type="date"
              value={data.invoiceDate}
              onChange={handleInvoiceDateChange}
              onInput={handleInvoiceDateChange}   
              onBlur={handleInvoiceDateChangeBlur}
              onKeyDown={handleInvoiceDateKeyDown}
              InputProps={{
                inputProps: {
                  min:
                    Type === 'Sales'
                      ? params?.id && !isNaN(params.id)
                        ? firstInvoiceDate ||(startDate && moment(startDate).isValid()? moment(startDate * 1000).format('YYYY-MM-DD'):"")
                        : lastInvoiceDate ||(startDate && moment(startDate).isValid()? moment(startDate * 1000).format('YYYY-MM-DD'):"")
                      : firstInvoiceDate || (startDate && moment(startDate).isValid()? moment(startDate * 1000).format('YYYY-MM-DD'):""),
                  max:
                    Type === 'Sales'
                      ? params?.id && !isNaN(params.id)
                        ? nextInvoiceDate || moment(endDate * 1000).format('YYYY-MM-DD')
                        : moment(endDate * 1000).format('YYYY-MM-DD')
                      : moment(endDate * 1000).format('YYYY-MM-DD'),
                },
                endAdornment: <LabelIcon value={data.invoiceDate} type="text" editMode={false} />,
              }}
              fullWidth
              sx={{
                '.MuiFormLabel-asterisk': {
                  color: 'danger.main',
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography
              sx={{
                marginTop: '2px',
                marginLeft: '10px',
                marginBottom: '0px',
                fontSize: '11px',
                color: 'danger.main',
              }}
            >
              {data?.errorFields.invoiceDate}
            </Typography>
          </Grid>
          {Type === 'Sales' || Type === 'Purchase' ? (
            <>
              <Grid item lg={2} xs={12} md={12}>
                <TextField
                  fullWidth
                  name="orderNumber"
                  id="orderNumber"
                  label={invoiceLabels.orderNumberName}
                  size="small"
                  type="text"
                  disabled={data.partyName.value === '' ? true : false}
                  value={data.orderNumber}
                  onChange={handleOrderNumberChange}
                />
              </Grid>
              <Grid item lg={data.currency.code === 'INR' ? 2 : 1.5} xs={12} md={12}>
                <TextField
                  error={data.errorStatus.customerOrderDate === true}
                  fullWidth
                  label={invoiceLabels.orderDateName}
                  type="date"
                  id="customerOrderDate"
                  name="customerOrderDate"
                  size="small"
                  disabled={data.partyName.value === ''}
                  value={data.customerOrderDate}
                  onChange={handleCustomerOrderDateChange} // ✅ Separate function for onChange
                  onKeyDown={handleCustomerOrderDateKeyDown}
                  onInput={handleCustomerOrderDateChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
    inputProps: {
      max: '9999-12-31', // Correct max date format (YYYY-MM-DD)
    },
  }}
                />
                <Typography
                  sx={{
                    marginTop: '2px',
                    marginLeft: '10px',
                    marginBottom: '0px',
                    fontSize: '11px',
                    color: 'danger.main',
                  }}
                >
                  {data?.errorFields.customerOrderDate}
                </Typography>
              </Grid>
            </>
          ) : (
            <>
              <Grid item lg={3} xs={12} md={12}>
                <Autocomplete
                  openOnFocus
                  disableClearable
                  size="small"
                  id="invVoucher"
                  options={originalInvoiceNos}
                  getOptionLabel={(option) => option.label}
                  disabled={data.partyName.value === ''}
                  value={data.originalInvoiceNumber}
                  onChange={handleInvoiceChange}
                  sx={{
                    '.MuiOutlinedInput-root': {
                      minHeight: '30px', // Match orderDate field height
                    },
                    '@media (max-width: 600px)': {
                      '.MuiOutlinedInput-root': {
                        minHeight: '70px', // Increase height only for mobile screens
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={
                        partyType === 'CUSTOMER' || (partyType === '' && Type === 'CreditNote')
                          ? 'Sales Invoice Number'
                          : 'Purchase Invoice Number'
                      }
                      error={data.errorStatus.originalInvoiceNumber === true}
                      InputLabelProps={{
                        shrink: true,
                        sx: { fontSize: '0.9rem' }, // Adjust label font size
                      }}
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          minHeight: '40px',
                          '@media (max-width: 600px)': {
                            minHeight: '70px',
                          },
                        },
                      }}
                    />
                  )}
                />

                {data?.originalInvoiceNumber?.value !== '' && (
                  <Typography
                    sx={{
                      justifyContent: 'flex-end',
                      marginTop: '5px',
                      marginLeft: '0px',
                      fontSize: '11px',
                      color: originalInvoiceNos?.length > 0 ? 'primary.main' : 'input.border',
                    }}
                  >
                    <Typography
                      href="#"
                      id="DisplayInvoice"
                      tabIndex={-1}
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        cursor: data?.originalInvoiceNumber?.value !== '' ? 'pointer' : '',
                        fontSize: '12px',
                        outline: 'none',
                        textDecoration: 'underline',
                      }}
                      disabled={originalInvoiceNos?.length > 0 ? false : true}
                      onClick={() => {
                        setItemListModalOpen(true);
                      }}
                    >
                      Display Invoice Line Items
                    </Typography>
                  </Typography>
                )}
                
              </Grid>
            
             
            </>
          )}
        </Grid>
      </Box>

      <Box
        sx={{
          m: 1,
          marginLeft: '0px',
          display: 'flex',
          alignItems: { sm: 'center' },
          flexWrap: { xs: 'wrap', md: 'nowrap' },
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        <Grid container spacing={2} sx={{ paddingTop: '5px', display: 'flex' }}>
          {(Type==="DebitNote" || Type==="CreditNote") &&(  <Grid item lg={2} xs={12} md={12}>
                  <TextField
                  id="partyNo"
                  label={partyType==="CUSTOMER"?"Customer Order Number":"Supplier Invoice Number"}
                  value={data?.partyInvNo}
                  size="small"
                  type='text'
                  fullWidth
                  onChange={handlePartyNumberChange}
                   InputLabelProps={{
                        shrink: true,
                        sx: { fontSize: '0.9rem' },
                      }}

                  />
                 </Grid>)}
          {registrationType != 1 && (
            <Grid item lg={2} xs={12} md={12}>
              <Autocomplete
                size="small"
                fullWidth
                openOnFocus
                autoFocus
                disableClearable
                id="taxability"
                name="taxability"
  getOptionDisabled={(option) => {
  const allowed =[2, 3, 5, 7, 9];
  const flag = data?.seriesVouchers?.serialflag === 1 ;

  
  if (Type === 'Sales' && generalSettingsFlag !== -1 && data?.placeOfSupply?.value!==96 && data?.partyName?.gstCategorey!=="SEZ") {
    return flag
      ? !allowed.includes(option.value)   
      : allowed.includes(option.value);   
  }
  return false;
}}

                options={
                  companyType == 3 && partyType === 'CUSTOMER'
                    ? compositeTaxabilityForCustomer
                    : companyType == 3 && partyType === 'SUPPLIER'
                    ? ['OC', 'UB'].includes(data?.partyCategory)
                      ? unrSupplierTaxability
                      : compositeTaxability
                    : data.placeOfSupply.value === 96
                    ? taxabilityOutsideIndia
                    : data?.partyCategory === 'SEZ'
                    ? customerTaxabilityOptions
                    : data?.partyCategory === 'UB' && partyType === 'SUPPLIER'
                    ? unrSupplierTaxability
                    : companyType === 3
                    ? compositeTaxability
                    : taxabilityOptions
                }
                value={data?.taxability}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                disabled={data?.partyName?.value === '' || data?.originalInvoiceNumber.length > 0 ? true : false}
                onChange={handleTaxabilityChangeWrapper}
                onKeyDown={handleTaxabilityKeyDown}
                renderInput={(params) => (
                  <TextField
                    error={data.errorStatus.taxability == true ? true : false}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...params}
                    label="Taxability"
                    required={true}
                  />
                )}
              />
              <Typography
                sx={{
                  marginTop: '2px',
                  marginLeft: '10px',
                  marginBottom: '0px',
                  fontSize: '11px',
                  color: 'danger.main',
                }}
              >
                {data?.errorFields.taxability}
              </Typography>
            </Grid>
          )}
          <Grid item lg={2} xs={12}>
            <TextField
              // type="number"
              disabled={data?.partyName?.value === '' ? true : false}
              fullWidth
              size="small"
              name="creditPeriod"
              id="creditPeriod"
              label="Credit Period (in days)"
              value={data.creditPeriod}
              onChange={handleCreditPeriodChange}
              onKeyDown={handleCreditpriodKerDown}
            />
          </Grid>
          <Grid item lg={2} xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ fontSize: '13px' }}>
              <span style={{ fontWeight: 600 }}>Due Date: </span> {data.dueDate?moment(data.dueDate).format('DD-MM-YYYY'):''}
            </Typography>
          </Grid>
          {Type === 'Sales' && (
            <Grid item lg={4} xs={12}>
              <Box sx={{ pl: 0.5 }}>
          

                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                  <Checkbox
                  
                    icon={<CheckBoxOutlineBlankOutlined fontSize="small" />}
                    checkedIcon={<CheckBox fontSize="small" />}
                    sx={{
                      '& svg': { fontSize: 18 },
                      p: 0.25,
                      mt: '-2px',
                      
                      
                    }}
                    checked={isSalesShow}
                    onChange={(e) => handleCheckboxChange(e.target.checked)}
                    label=""
                  />

                  <Typography variant="body2" sx={{ fontSize: '14px', color: 'primary.main' }}>
                 Enable Invoice Sharing Popup
                  </Typography>
                </Box>
              </Box>
            </Grid>
          )}
          {(partyType === 'SUPPLIER' && Number(companyType===2) && ![2,3,5,7,9].includes(data?.taxability?.value))&& (
            <Grid item lg={4} xs={12}>
              <Box sx={{ pl: 0.5 }}>
          

                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                  <Tooltip
                     title="If enabled, GST Input Tax Credit (ITC) will not be claimed for this transaction. Use this when the supplier invoice is not eligible for ITC as per GST rules."
                   arrow>
                  <Checkbox
                  
                    icon={<CheckBoxOutlineBlankOutlined fontSize="small" />}
                    checkedIcon={<CheckBox fontSize="small" />}
                    sx={{
                      '& svg': { fontSize: 18 },
                      p: 0.25,
                      mt: '-2px',
                      
                      
                    }}
                    value={data?.ITCFlag}
                    checked={Number(data?.ITCFlag)===1?true:false}
                    onChange={(e) => handleITCFlag(e.target.checked)}
                    label=""
                  />
                  </Tooltip>

                  <Typography variant="body2" sx={{ fontSize: '14px', color: 'primary.main' }}>
                 Exclude from ITC 
                  </Typography>
                </Box>
              </Box>
            </Grid>
          )}

          {(data?.taxability?.value == 2 || data?.taxability?.value == 3 || data?.taxability?.value == 5) &&
            !params?.id &&
            (Type === 'Sales' || Type === 'Pos') &&
            companyType !== 3 && (
              <Typography sx={{ color: 'red', m: 2, fontSize: '12px', maxWidth: '1000px' }}>
                *Note: If the supply is Exempted, Non-GST, or Out of Scope, the document will be treated as a Bill of Supply instead of a
                Tax Invoice.
              </Typography>
            )}
        </Grid>
      </Box>

      {ledgerModal === true && (
        <LedgerTransactionModalv2
          open={showTransactionModal}
          onClose={() => {
            setShowTransactionModal(false);
          }}
          accountId={partyAccountID}
        />
      )}
      {itemListModalOpen === true && (
        <NewItemListModal
          open={itemListModalOpen}
          setOpen={setItemListModalOpen}
          placeOfSupply={data.placeOfSupply.value}
          companyState={companyState}
          items={items}
          nonItems={nonItems}
          registrationType={registrationType}
          setItems={setItems}
          itemArr={purchaseArr}
          setItemArr={setPurchaseArr}
          invNumber={data.originalInvoiceNumber}
          accNames={accNames}
          unitsObj={unitsObj}
          partyType={partyType}
          data={data}
          setData={setData}
          Type={Type}
          handleTaxabilityChange={(newValue, arr, nonItems) => {
            handleTaxabilityChange(newValue, arr, nonItems);
          }}
        />
      )}
      {openPartyModal === true && (
        <AddNewPartyModal
          open={openPartyModal}
          setOpen={setOpenPartyModal}
          partyType={Type === 'Purchase' ? 'supplier' : Type === 'Sales' ? 'customer' : partyType === 'SUPPLIER' ? 'supplier' : 'customer'}
          setNewPartyID={setNewPartyID}
          setPartyType={setPartyType}
          page={Type}
          partyParamsID={partyParamsID}
          Type={'Party'}
          newPartyName={partyParamsID?data?.partyName?.label:''}
          listPartyDetails={(newPartyID) => handlePartyCategoryChange(newPartyID)}
        />
      )}
      <PageResetModal
        open={openResetModal}
        setOpen={setOpenResetModal}
        newChangeValue={newChangeValue}
        setNewChangeValue={setNewChangeValue}
        newPartyID={newPartyID}
        setNewPartyID={setNewPartyID}
        onChange={
          newChangeValue?.type === 'party' ? (partyData) => partyOnchange(partyData) : (newValue) => changeInPlaceOfSupply(newValue)
        }
      />
    </Box>
  );
}

export default memo(InvoiceBasicDetails);
